<template>
    <div>
      <base-header
        type="gradient-danger"
        class="pb-6 pb-8 pt-5 pt-md-8"
      ></base-header>
      <b-modal hide-footer title="Existencias" v-model="showExistencias">
        <div v-if="showLoaderExistencia">
          <center>
            <img src="img/loader.gif" class="img-responsive" style="width:50px" />
            <br />Cargando existencia...
          </center>
        </div>
        <div v-if="!showLoaderExistencia && ItemWarehouseInfo.ItemName">
          <h4>
            {{ ItemWarehouseInfo.ItemName }}
            <br />
            <span style="font-weight:normal">
              {{
              ItemWarehouseInfo.ItemCode
              }}
            </span>
          </h4>
          <div class="row">
            <div v-if="ItemWarehouseInfo.ItemWarehouseInfoCollection.length === 0">
              <h5
                v-if="
                  item.InStock > 0
                "
              >
                <strong style="color:red;">Sin Stock</strong>
              </h5>
            </div>
            <base-table thead-classes="thead-light" :data="ItemWarehouseInfo.ItemWarehouseInfoCollection">
                <template slot="columns">
                  <th><center>Almacén</center></th>
                  <th><center>Stock</center></th>
                  <th><center>Comprometido</center></th>
                  <th></th>
                </template>
                <template slot-scope="{ row }">
                  <th scope="row">
                    <center>
                      <a style="font-size: 12px">{{ row.WarehouseCode }} </a>
                    </center>
                  </th>
                  <th scope="row">
                    <center>
                      <a style="font-size: 12px">{{ row.InStock }} </a>
                    </center>
                  </th>
                  <th scope="row">
                    <center>
                      <a style="font-size: 12px">{{ row.Committed }} </a>
                    </center>
                  </th>
                </template>
            </base-table>
          </div>
        </div>
      </b-modal>
      <b-modal hide-footer no-close-on-backdrop no-close-on-esc v-model="showDetalles" v-if="OPselected" size="xl" title="Orden de fabricación" centered>
        <div> 
          <div class="row" style="margin-top:-35px">
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Tipo:  </span>
                </div>
                <div class="col-sm-9">
                  <!-- <base-dropdown style="padding-bottom:12px;" v-if="showEdicion">
                    <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                      {{ getTipo(OPnueva.ProductionOrderType) }}
                    </base-button>
  
                    <a
                      class="dropdown-item"
                      @click="OPnueva.ProductionOrderType = 'bopotStandard';"
                      >Estándar
                    </a>
                    <a
                      class="dropdown-item"
                      @click="OPnueva.ProductionOrderType = 'bopotSpecial';"
                      >Especial
                    </a>
                    <a
                      class="dropdown-item"
                      @click="OPnueva.ProductionOrderType = 'bopotDisassembly';"
                      >Desmontaje
                    </a>
                  </base-dropdown> -->
                  <base-input :value="getTipo(OPselected.ProductionOrderType)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px">Status:</span>
                </div>
                <div class="col-sm-9">
                  <base-input :value="getStatus(OPselected.ProductionOrderStatus)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px;" disabled></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px;">
                  <span style="font-weight:normal;font-size:12px">Producto: </span>
                </div>
                <div class="col-sm-9">
                <!--  <multiselect
                    v-model="NewProduct"
                    :options="products"
                    v-if="products != [] && showEdicion"
                    placeholder="Buscar"
                    label="TreeCode"
                    track-by="TreeCode"
                    @select="dispatchActionProductEdit"
                    style="font-size:12px;margin-bottom:3px"
                  ></multiselect> -->
                  <base-input :value="OPselected.ItemNo" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Descripción de producto</span>
                </div>
                <div class="col-sm-9" style="padding-top:10px">
                  <base-input :value="OPselected.ProductDescription" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Cantidad planificada: </span>
                </div>
                <div class="col-sm-9" style="padding-top:10px">
                  <base-input :disabled="!showEdicion" type="number" v-model="OPselected.PlannedQuantity" @change="updatePlannedQuantitySelected" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-sm-3" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Unidad medida</span>
                </div>
                <div class="col-sm-9" style="padding-top:10px">
                  <base-input :value="OPnueva.InventoryUOM" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div> -->
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px">Almacén: </span>
                </div>
                <div class="col-sm-9">
                  <base-dropdown style="padding-bottom:12px;" v-if="showEdicion">
                    <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                      {{ OPselected.Warehouse }}
                    </base-button>
                    <a
                      v-for="item in warehouses"
                      v-bind:key="item.WarehouseCode"
                      class="dropdown-item"
                      @click="OPselected.Warehouse = item.WarehouseCode;"
                      >{{item.WarehouseCode}}
                    </a>
                  </base-dropdown>
                  <base-input v-if="!showEdicion" disabled type="text" v-model="OPselected.Warehouse" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px">Almacén de materia prima: </span>
                </div>
                <div class="col-sm-9">
                  <base-dropdown style="padding-bottom:12px;" v-if="showEdicion">
                    <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                      {{ OPselected.ProductionOrderLines[0].Warehouse }}
                    </base-button>
                    <a
                      v-for="item in warehouses"
                      v-bind:key="item.WarehouseCode"
                      class="dropdown-item"
                      @click="OPselected.WarehouseMP = item.WarehouseCode;OPselected.ProductionOrderLines[0].Warehouse = item.WarehouseCode"
                      >{{item.WarehouseCode}}
                    </a>
                  </base-dropdown>
                  <base-input v-if="!showEdicion" disabled type="text" v-model="OPselected.ProductionOrderLines[0].Warehouse " style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px;">
                  <span type="number" style="font-weight:normal;font-size:12px;">Prioridad:</span>
                </div>
                <div class="col-sm-9">
                  <base-input disabled type="number" v-model="OPselected.Priority" max="100" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3" style="padding-top:10px;">
                  <span style="font-weight:normal;font-size:12px">Fecha Enrutamiento:</span>
                </div>
                <div class="col-sm-9" style="padding-top:10px">
                  <base-input :value="getFechaEnrutamiento(OPselected.RoutingDateCalculation)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-4"></div> -->
            <div class="col-sm-6">
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px">Nº:</span>
                </div>
                <div class="col-sm-6">
                  <base-input :value="OPselected.DocumentNumber" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px">Fecha del pedido:</span>
                </div>
                <div class="col-sm-6">
                  <base-input :value="OPselected.CreationDate" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Fecha de inicio:</span>
                </div>
                <div class="col-sm-6">
                  <base-input style="cursor: pointer; margin-bottom:8px">
                    <flat-picker
                      :disabled="!showEdicion"
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur;"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="OPselected.StartDate"
                      style="cursor: pointer; padding-left: 20px;transform: scale(0.775);transform-origin:left"
                    >
                    </flat-picker>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Fecha de termino:</span>
                </div>
                <div class="col-sm-6">
                  <base-input style="cursor: pointer; margin-bottom:8px">
                    <flat-picker
                      :disabled="!showEdicion"
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur;"
                      :config="{ allowInput: true }"
                      class="form-control datepicker"
                      v-model="OPselected.DueDate"
                      style="cursor: pointer; padding-left: 20px;transform: scale(0.775);transform-origin:left"
                    >
                    </flat-picker>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Usuario:</span>
                </div>
                <div class="col-sm-6">
                  <base-input v-if="usersList.length" :value="getUserPerson(OPselected.UserSignature).UserCode" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Origen:</span><br>
                </div>
                <div class="col-sm-6">
                  <base-input :value="getOrigen(OPselected.ProductionOrderOrigin)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Pedido de cliente:</span>
                </div>
                <div class="col-sm-6">
                  <base-input :disabled="!showEdicion" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Norma reparto:</span>
                </div>
                <div class="col-sm-6">
                  <base-input :disabled="!showEdicion" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6" style="padding-top:10px">
                  <span style="font-weight:normal;font-size:12px;">Proyecto:</span>
                </div>
                <div class="col-sm-6">
                  <base-input :disabled="!showEdicion" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <div class="row" style="float:right;padding-right:70px">
                <span style="padding-top:25px;font-size:10px;">
                  {{OPselected.Remarks}}
                </span>
              </div>
            </div>
          </div>
          <hr>
          <div class="row">
              <div class="col-sm-4" style="padding-left:30px">
                <div class="row">
                  <span style="font-weight:normal;font-size:12px;">Categoría</span>
                </div>
                <div class="row">
                  <base-dropdown style="padding-bottom:12px;" v-if="showEdicion">
                    <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                      {{ getCategory(OPselected.U_Category) }}
                    </base-button>
                    <a
                      v-for="item in categories"
                      v-bind:key="item.value"
                      class="dropdown-item"
                      @click="selectCategorySelected(item)"
                      >{{item.Description}}
                    </a>
                  </base-dropdown>
                  <base-input v-if="!showEdicion" disabled :value="getCategory(OPselected.U_Category)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="row">
                  <span style="font-weight:normal;font-size:12px;">Nº Orden de Producción Maestra</span>
                </div>
                <div class="row">
                  <base-input disabled :value="OPselected.U_MasterProduction" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="row">
                  <span style="font-weight:normal;font-size:12px;">Método</span>
                </div>
                <div class="row">
                  <!-- <base-input v-if="is06 && this.listaSecundaria" :value="OPnueva.U_MethodDescription" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                  <base-dropdown v-if="!this.listaSecundaria" style="padding-bottom:12px;">
                    <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                      {{ OPnueva.U_MethodDescription }}
                    </base-button>
                    <a
                      v-for="item in methods"
                      v-bind:key="item.value"
                      class="dropdown-item"
                      @click="OPnueva.U_MethodDescription = item.Description;OPnueva.U_Method = item.Value;medidaPerfilar= null; if(item.value != '1'){ OPnueva.ProductionOrderLines = OldProductionOrdersLines }"
                      >{{item.Description}}
                    </a>
                  </base-dropdown> -->
                  <base-input disabled :value="getMethod(OPselected.U_Method)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                </div>
              </div>  
          </div>
          <hr>
          <base-button
            v-if="(OPselected.ProductionOrderStatus === 'boposPlanned' || OPselected.ProductionOrderStatus === 'boposReleased') && !showEdicion && OPselected.U_MasterProduction===null"
            style="float: left"
            size="sm"
            tag="a"
            type="default"
            href="#"
            class="active"
            role="button"
            aria-pressed="true"
            @click="showEdicion = true"
            >HABILITAR MODIFICACIÓN</base-button
          >
          <base-button
            style="float: left"
            size="sm"
            tag="a"
            type="default"
            href="#"
            class="active"
            role="button"
            aria-pressed="true"
            @click="duplicarOP"
            >DUPLICAR</base-button
          >
          <base-button
            v-if="OPselected.ProductionOrderStatus === 'boposReleased' && !loadingStatus && OPselected.U_MasterProduction===null"
            style="float: right"
            size="sm"
            tag="a"
            type="success"
            href="#"
            class="active"
            role="button"
            aria-pressed="true"
            @click="cerrarOrden"
            >CREAR RECIBO DE PRODUCCIÓN</base-button
          >
          <base-button
            v-if="OPselected.ProductionOrderStatus === 'boposPlanned' && !loadingStatus && OPselected.U_MasterProduction===null"
            style="float: right"
            size="sm"
            tag="a"
            type="success"
            href="#"
            class="active"
            role="button"
            aria-pressed="true"
            @click="liberarOrden"
            >LIBERAR</base-button
          >
          <div style="float:right" v-if="loadingStatus">
            <br>
            <img src="img/loader.gif" class="img-responsive" style="width: 50px" />
            <br />
            Aplicando...
          </div>
          <br>
          <br>
          <div class="row mt-2">
            <div class="col-sm-12">
              <h4>Componentes</h4>
              <base-table thead-classes="thead-light" :data="OPselected.ProductionOrderLines">
                <template slot="columns">
                  <th><center>Nº</center></th>
                  <th><center>Cant. base</center></th>
                  <th><center>Cant. nominal</center></th>
                  <th><center>Cant. adicional</center></th>
                  <th><center>Cant. planificada</center></th>
                  <th></th>
                </template>
                <template slot-scope="{ row, index }">
                  <th scope="row">
                    <center>
                      <a style="font-size: 12px">{{ row.ItemNo }} </a>
                    </center>
                  </th>
                  <th scope="row">
                    <center>
                      <a style="font-size: 12px">{{ row.BaseQuantity }} </a>
                    </center>
                  </th>
                  <th scope="row">
                    <center>
                      <a style="font-size: 12px">{{ (row.BaseQuantity * OPselected.PlannedQuantity).toFixed(5) }} </a>
                    </center>
                  </th>
                  <th scope="row">
                    <center>
                      <a v-if="!showEdicion" style="font-size: 12px">{{ row.AdditionalQuantity.toFixed(5) }} </a>
                      <base-input v-if="showEdicion" v-model="OPselected.ProductionOrderLines[index].AdditionalQuantity" @change="updateMermaOP(index)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                    </center>
                  </th>
                  <th scope="row">
                    <center>
                      <a style="font-size: 12px">{{ ((row.BaseQuantity * OPselected.PlannedQuantity)+row.AdditionalQuantity).toFixed(5) }} </a>
                    </center>
                  </th>
                  <th scope="row">
                  <center>
                    <a href="#" @click="verStock(row.ItemNo)" style="font-size: 12px"> Ver Stock </a>
                  </center>
                </th>
                </template>
              </base-table>
              <!-- <div v-if="is06">
                <input   
                  type="checkbox" 
                  v-model="listaSecundaria" 
                  @click="checkListaMateriales(listaSecundaria)"
                > 
                Usar lista de materiales secundaria
              </div> -->
                
              <!-- <base-button
                style="float: left"
                size="sm"
                tag="a"
                type="success"
                href="#"
                class="active"
                role="button"
                aria-pressed="true"
                @click="showNuevoComponente = true"
                >AGREGAR COMPONENTE</base-button
              > -->
              <!-- <base-button
                style="float: right"
                size="sm"
                tag="a"
                type="success"
                href="#"
                class="active"
                role="button"
                aria-pressed="true"
                @click="crearOrden"
                >Crear Orden de Producción</base-button
              > -->
            </div>
          </div>
          <center v-if="showLoaderAplicando">
            <img src="img/loader.gif" class="img-responsive" style="width: 50px" />
            <br />
            Aplicando...
          </center>
          <div>
            <base-button
              v-if="showEdicion && !showLoaderAplicando"
              style="float: right"
              tag="a"
              type="primary"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="updateOP"
              >Modificar orden de producción</base-button
            >
          </div>
        </div>
      </b-modal>
      <b-modal ok-only ok-title="Agregar" v-model="showNuevoComponente" size="sm" title="Agregar un componente" centered>
        <div class="row" style="margin-top:-35px">
          <div class="col-sm-12">
            <span style="font-weight:normal;font-size:14px">Producto</span><br>
            <multiselect
              v-model="NewProductNotTree"
              :options="productsNotTree"
              v-if="productsNotTree != []"
              placeholder="Buscar"
              label="ItemCode"
              track-by="ItemCode"
              style="font-size:14px"
              @select="dispatchActionNewComponent"
            ></multiselect>
            <!-- {{NewProductNotTree}} -->
            <div v-if="showEdicion == false" style="padding-top:5px">
              <!-- <span style="font-weight:normal;font-size:14px;">Código de producto</span><br>
              <base-input :value="OPnueva.ItemNo" style="transform: scale(0.875);transform-origin:left;margin-bottom:3px" disabled></base-input> -->
              <span v-if="NewProductNotTree" style="font-weight:normal;font-size:14px;">Descripción de producto</span><br>
              <base-input v-if="NewProductNotTree" :value="NewComponent.ItemNo" style="transform: scale(0.875);transform-origin:left;margin-bottom:3px" disabled></base-input>
            </div>
            <span v-if="NewProductNotTree" style="font-weight:normal;font-size:14px;">Factor</span><br>
            <base-input v-if="NewProductNotTree" type="number" v-model="factor" @change="updatePlannedQuantity" style="transform: scale(0.875);transform-origin:left;margin-bottom:3px"></base-input>
  
            <span v-if="NewProductNotTree" style="font-weight:normal;font-size:14px;">Cantidad base</span><br>
            <base-input v-if="NewProductNotTree" type="number" v-model="NewComponent.BaseQuantity" @change="updatePlannedQuantity" style="transform: scale(0.875);transform-origin:left;margin-bottom:3px"></base-input>
            
            <span v-if="NewProductNotTree" style="font-weight:normal;font-size:14px;">Cantidad planificada</span><br>
            <base-input v-if="NewProductNotTree" type="number" v-model="NewComponent.PlannedQuantity" @change="updatePlannedQuantity" style="transform: scale(0.875);transform-origin:left;margin-bottom:3px"></base-input>
  
            <span v-if="NewProductNotTree" style="font-weight:normal;font-size:14px">Almacén</span><br>
            <base-dropdown style="padding-bottom:12px" v-if="NewProductNotTree">
              <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                {{ NewProductNotTree.DefaultWarehouse }}
              </base-button>
              <a
              v-for="item in warehouses"
                v-bind:key="item.WarehouseCode"
                class="dropdown-item"
                @click="NewProductNotTree.DefaultWarehouse = item.WarehouseCode;"
                >{{item.WarehouseCode}}
              </a>
            </base-dropdown>
          </div>
        </div>
        <template #modal-footer="{ ok, cancel, hide }">
          <b-button size="sm" variant="success" @click="ok()">
            OK
          </b-button>
          <b-button size="sm" variant="danger" @click="cancel()">
            Cancel
          </b-button>
          <b-button size="sm" variant="outline-secondary" @click="hide('forget')">
            Forget it
          </b-button>
        </template>
      </b-modal>
      <b-modal hide-footer no-close-on-backdrop no-close-on-esc v-model="showNuevo" size="xl" title="Nueva Orden de Fabricación" centered>
        <div class="row" style="margin-top:-35px">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Tipo:  </span>
              </div>
              <div class="col-sm-9">
                <base-input :value="getTipo(OPnueva.ProductionOrderType)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                <!-- <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ getTipo(OPnueva.ProductionOrderType) }}
                  </base-button>
  
                  <a
                    class="dropdown-item"
                    @click="OPnueva.ProductionOrderType = 'bopotStandard';"
                    >Estándar
                  </a>
                  <a
                    class="dropdown-item"
                    @click="OPnueva.ProductionOrderType = 'bopotSpecial';"
                    >Especial
                  </a>
                  <a
                    class="dropdown-item"
                    @click="OPnueva.ProductionOrderType = 'bopotDisassembly';"
                    >Desmontaje
                  </a>
                </base-dropdown> -->
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Status:</span>
              </div>
              <div class="col-sm-9">
                <base-input :value="getStatus(OPnueva.ProductionOrderStatus)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px;" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span style="font-weight:normal;font-size:12px">Producto: </span>
              </div>
              <div class="col-sm-9">
                <multiselect
                  v-model="NewProduct"
                  :options="products"
                  v-if="products != []"
                  placeholder="Buscar"
                  label="TreeCode"
                  track-by="TreeCode"
                  @select="dispatchActionProductNew"
                  style="font-size:12px;margin-bottom:3px"
                ></multiselect>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Descripción de producto</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="OPnueva.ProductDescription" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Cantidad planificada: </span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input type="number" v-model="OPnueva.PlannedQuantity" @change="updatePlannedQuantity" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Unidad medida</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="OPnueva.InventoryUOM" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div> -->
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Almacén: </span>
              </div>
              <div class="col-sm-9">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPnueva.Warehouse }}
                  </base-button>
                  <a
                    v-for="item in warehouses"
                    v-bind:key="item.WarehouseCode"
                    class="dropdown-item"
                    @click="OPnueva.Warehouse = item.WarehouseCode;"
                    >{{item.WarehouseCode}}
                  </a>
                </base-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Almacén de materia prima: </span>
              </div>
              <div class="col-sm-9">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPnueva.WarehouseMP }}
                  </base-button>
                  <a
                    v-for="item in warehouses"
                    v-bind:key="item.WarehouseCode"
                    class="dropdown-item"
                    @click="OPnueva.WarehouseMP = item.WarehouseCode;"
                    >{{item.WarehouseCode}}
                  </a>
                </base-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span type="number" style="font-weight:normal;font-size:12px;">Prioridad:</span>
              </div>
              <div class="col-sm-9">
                <base-input disabled type="number" v-model="OPnueva.Priority" max="100" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span style="font-weight:normal;font-size:12px">Fecha Enrutamiento:</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="getFechaEnrutamiento(OPnueva.RoutingDateCalculation)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-4"></div> -->
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Nº:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Fecha del pedido:</span>
              </div>
              <div class="col-sm-6">
                <base-input :value="OPnueva.CreationDate" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Fecha de inicio:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="cursor: pointer; margin-bottom:8px">
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur;"
                    :config="{ allowInput: true }"
                    class="form-control datepicker"
                    v-model="OPnueva.StartDate"
                    style="cursor: pointer; padding-left: 20px;transform: scale(0.775);transform-origin:left"
                  >
                  </flat-picker>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Fecha de termino:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="cursor: pointer; margin-bottom:8px">
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur;"
                    :config="{ allowInput: true }"
                    class="form-control datepicker"
                    v-model="OPnueva.DueDate"
                    style="cursor: pointer; padding-left: 20px;transform: scale(0.775);transform-origin:left"
                  >
                  </flat-picker>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Usuario:</span>
              </div>
              <div class="col-sm-6">
                <base-input v-if="usersList.length > 0 && OPnueva.UserSignature" :value="getUserPerson(OPnueva.UserSignature).UserCode" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Origen:</span><br>
              </div>
              <div class="col-sm-6">
                <base-input :value="getOrigen(OPnueva.ProductionOrderOrigin)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Pedido de cliente:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Norma reparto:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Proyecto:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                
              </div>
              <div class="col-sm-6" style="padding-right:70px;">
                
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-sm-4" style="padding-left:30px">
              <div class="row">
                <span style="font-weight:normal;font-size:12px;">Categoría</span>
              </div>
              <div class="row">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPnueva.U_CategoryDescription }}
                  </base-button>
                  <a
                    v-for="item in categories"
                    v-bind:key="item.value"
                    class="dropdown-item"
                    @click="selectCategory(item)"
                    >{{item.Description}}
                  </a>
                </base-dropdown>
                <!-- <base-input :value="OPnueva.U_Category" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input> -->
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <span style="font-weight:normal;font-size:12px;">Orden de Producción Maestra</span>
              </div>
              <div class="row">
                <base-input disabled :value="OPnueva.U_MasterProduction" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div v-if="!loadingProductTree" class="col-sm-4">
              <div class="row">
                <span style="font-weight:normal;font-size:12px;">Método</span>
              </div>
              <div class="row">
                <!-- <base-input v-if="is06 && this.listaSecundaria" :value="OPnueva.U_MethodDescription" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input> -->
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPnueva.U_MethodDescription }}
                  </base-button>
                  <a
                    v-for="item in methods"
                    v-bind:key="item.value"
                    class="dropdown-item"
                    @click="selectMethod(item)"
                    >{{item.Description}}
                  </a>
  
                </base-dropdown>
              </div>
              <div class="row" v-if="showOptionsBlister">
                <base-dropdown v-if="!this.listaSecundaria" style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ blisterOption }}
                  </base-button>
                  <a
                    class="dropdown-item"
                    @click="selectMethodBlister('tiras')"
                    >Tiras
                  </a>
                  <a
                    class="dropdown-item"
                    @click="selectMethodBlister('master engomado')"
                    >Master Engomado
                  </a>
                  <a
                    class="dropdown-item"
                    @click="selectMethodBlister('blancos')"
                    >Blancos
                  </a>
  
                </base-dropdown>
              </div>
              <div class="row" v-if="OPnueva.U_Method == '1'">
                  <span style="font-weight:normal;font-size:12px;">Selecciona el rollo que se va a a perfilar</span>
              </div>
              <div class="row" v-if="OPnueva.U_Method == '1'">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ medidaPerfilar}}
                  </base-button>
                  <a
                    v-for="item in medidas"
                    v-bind:key="item.ItemCode"
                    class="dropdown-item"
                    @click="agregarPerfilado(item)"
                    >{{item.ItemCode}}
                  </a>
  
                </base-dropdown>
              </div>
            </div>
            <div v-else>
              Obteniendo lista de materiales...
            </div>
            
        </div>
        <hr>
        <div class="row mt-2">
          <div class="col-sm-12">
            <h3>Componentes</h3>
            <h4 style="color:#c0392b" v-if="OPnueva.U_MethodDescription === 'Lista de componentes del sistema'">* Se esta utilizando la lista de componentes del sistema</h4>
            <base-table thead-classes="thead-light" :data="OPnueva.ProductionOrderLines">
              <template slot="columns">
                <th><center>Nº</center></th>
                <th><center>Cant. base</center></th>
                <th><center>Cant. adicional</center></th>
                <th><center>Cant. planificada</center></th>
                <th><center>Cant. nominal</center></th>
                <th v-if="blisterOption == 'Blancos'"><center></center></th>
                <th><center></center></th>
              </template>
              <template slot-scope="{ row }">
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.ItemNo }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.BaseQuantity }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.AdditionalQuantity }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ ((row.BaseQuantity * OPnueva.PlannedQuantity)+row.AdditionalQuantity).toFixed(5) }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ (row.BaseQuantity * OPnueva.PlannedQuantity).toFixed(5) }} </a>
                  </center>
                </th>
                <th scope="row" v-if="blisterOption == 'Blancos'">
                  <center>
                    <base-dropdown style="padding-bottom:12px;">
                      <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                        {{ row.Warehouse }}
                      </base-button>
                      <a
                        v-for="item in warehouses"
                        v-bind:key="item.WarehouseCode"
                        class="dropdown-item"
                        @click="row.Warehouse = item.WarehouseCode;"
                        >{{item.WarehouseCode}}
                      </a>
                    </base-dropdown>
                  </center>
                </th>
                
                <th scope="row">
                  <center>
                    <a href="#" @click="verStock(row.ItemNo)" style="font-size: 12px"> Ver Stock </a>
                  </center>
                </th>
              </template>
            </base-table>
            <div v-if="OPnueva.U_MethodDescription != 'Lista de componentes del sistema'">
              <input   
                type="checkbox" 
                v-model="listaSecundaria" 
                @click="checkListaMateriales(listaSecundaria)"
              > 
              Usar lista de componentes del sistema
            </div>
              
            <!-- <base-button
              style="float: left"
              size="sm"
              tag="a"
              type="success"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="showNuevoComponente = true"
              >AGREGAR COMPONENTE</base-button
            > -->
            <!-- <base-button
              style="float: right"
              size="sm"
              tag="a"
              type="success"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="crearOrden"
              >Crear Orden de Producción</base-button
            > -->
          </div>
        </div>
        <center v-if="loaderCrearOP">
          <img src="img/loader.gif" class="img-responsive" style="width: 50px" />
          <br />
          Creando Orden de Producción...
        </center>
        <div>
          <base-button
              v-if="!loaderCrearOP"
              style="float: right"
              tag="a"
              type="primary"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="crearOrden"
              >Crear orden de producción</base-button
            >
            <!-- <base-button
              v-if="!loaderCrearOP"
              style="float: right"
              tag="a"
              type="primary"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="demoDialog"
              >Crear orden de producción DEMO</base-button
            > -->
        </div>
      </b-modal>
      <b-modal hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-model="showEdicionOPM" size="xl" title="Modificar Orden de Fabricación Maestra" centered>
        <base-button 
          v-if="!loadingStatus"  
          style="float: right; margin-top: -70px"
          tag="a"
          type="decondary"
          href="#"
          class="active"
          role="button"
          aria-pressed="true"
          @click="showEdicionOPM = false">
          X
        </base-button>
        <div class="row" style="margin-top:-35px">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Tipo:  </span>
              </div>
              <div class="col-sm-9">
                <base-input :value="getTipo(OPMaestraEditar.ProductionOrderType)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                <!-- <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ getTipo(OPMaestraEditar.ProductionOrderType) }}
                  </base-button>
                  <a
                    class="dropdown-item"
                    @click="OPMaestraEditar.ProductionOrderType = 'bopotStandard';"
                    >Estándar
                  </a>
                  <a
                    class="dropdown-item"
                    @click="OPMaestraEditar.ProductionOrderType = 'bopotSpecial';"
                    >Especial
                  </a>
                  <a
                    class="dropdown-item"
                    @click="OPMaestraEditar.ProductionOrderType = 'bopotDisassembly';"
                    >Desmontaje
                  </a>
                </base-dropdown> -->
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Status:</span>
              </div>
              <div class="col-sm-9">
                <base-input :value="getStatus(OPMaestraEditar.ProductionOrderStatus)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px;" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span style="font-weight:normal;font-size:12px">Materia Prima: </span>
              </div>
              <div class="col-sm-9">
                <base-input :value="OPMaestraEditar.ItemNo" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                <!-- <multiselect
                  v-model="NewProductMaster"
                  :options="masters"
                  placeholder="Buscar"
                  label="ItemCode"
                  track-by="ItemCode"
                  @select="dispatchActionProductMaster"
                  style="font-size:12px;margin-bottom:3px"
                ></multiselect> -->
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Descripción de materia prima:</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="OPMaestraEditar.ProductDescription" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div> -->
            <!-- <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Cantidad planificada: </span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input type="number" v-model="OPMaestraNueva.PlannedQuantity" @change="updatePlannedQuantity" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div> -->
            <!-- <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Unidad medida</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="OPnueva.InventoryUOM" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div> -->
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Almacén: </span>
              </div>
              <div class="col-sm-9">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPMaestraEditar.Warehouse }}
                  </base-button>
                  <a
                    v-for="item in warehouses"
                    v-bind:key="item.WarehouseCode"
                    class="dropdown-item"
                    @click="OPMaestraEditar.Warehouse = item.WarehouseCode;"
                    >{{item.WarehouseCode}}
                  </a>
                </base-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Almacén de materia prima: </span>
              </div>
              <div class="col-sm-9">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPMaestraEditar.WarehouseMP }}
                  </base-button>
                  <a
                    v-for="item in warehouses"
                    v-bind:key="item.WarehouseCode"
                    class="dropdown-item"
                    @click="OPMaestraEditar.WarehouseMP = item.WarehouseCode;"
                    >{{item.WarehouseCode}}
                  </a>
                </base-dropdown>
                <a href="#" @click="verStock(OPMaestraEditar.ItemNo)" style="font-size: 12px"> Ver Stock </a>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span type="number" style="font-weight:normal;font-size:12px;">Prioridad:</span>
              </div>
              <div class="col-sm-9">
                <base-input disabled type="number" v-model="OPMaestraEditar.Priority" max="100" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span style="font-weight:normal;font-size:12px">Fecha Enrutamiento:</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="getFechaEnrutamiento(OPMaestraEditar.RoutingDateCalculation)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span style="font-weight:normal;font-size:12px">Emisión:</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="getEmision(OPMaestraEditar.emisionMethod)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-4"></div> -->
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Nº:</span>
              </div>
              <div class="col-sm-6">
                <base-input :value="'OPM '+OPMaestraEditar.U_MasterProduction" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Fecha del pedido:</span>
              </div>
              <div class="col-sm-6">
                <base-input :value="OPMaestraEditar.CreationDate" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Fecha de inicio:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="cursor: pointer; margin-bottom:8px">
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur;"
                    :config="{ allowInput: true }"
                    class="form-control datepicker"
                    v-model="OPMaestraEditar.StartDate"
                    style="cursor: pointer; padding-left: 20px;transform: scale(0.775);transform-origin:left"
                  >
                  </flat-picker>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Fecha de termino:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="cursor: pointer; margin-bottom:8px">
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur;"
                    :config="{ allowInput: true }"
                    class="form-control datepicker"
                    v-model="OPMaestraEditar.DueDate"
                    style="cursor: pointer; padding-left: 20px;transform: scale(0.775);transform-origin:left"
                  >
                  </flat-picker>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Usuario:</span>
              </div>
              <div class="col-sm-6">
                <base-input v-if="usersList.length > 0 && OPMaestraEditar.UserSignature" :value="getUserPerson(OPMaestraEditar.UserSignature).UserCode" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Origen:</span><br>
              </div>
              <div class="col-sm-6">
                <base-input :value="getOrigen(OPMaestraEditar.ProductionOrderOrigin)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Categoría:</span>
              </div>
              <div class="col-sm-6">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPMaestraEditar.U_CategoryDescription }}
                  </base-button>
                  <a
                    v-for="item in categories"
                    v-bind:key="item.value"
                    class="dropdown-item"
                    @click="selectCategoryMaster(item)"
                    >{{item.Description}}
                  </a>
                </base-dropdown>
              </div>
            </div> -->
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Merma: </span>
              </div>
              <div class="col-sm-6" style="padding-top:10px">
                <base-input type="number" v-model="OPMaestraEditar.Merma" @change="updateMermaOPM" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            
            <div class="row" style="float: right;padding-right:70px;padding-top:10px">
              <base-button
                v-if="OPMaestraEditar.ProductionOrderStatus === 'boposReleased' && !loadingStatus"
                style="float: left"
                size="sm"
                tag="a"
                type="success"
                href="#"
                class="active"
                role="button"
                aria-pressed="true"
                @click="cerrarOPM"
                >CREAR RECIBO DE PRODUCCIÓN</base-button
              >
              <base-button
                v-if="OPMaestraEditar.ProductionOrderStatus === 'boposPlanned' && !loadingStatus"
                style="float: left"
                size="sm"
                tag="a"
                type="success"
                href="#"
                class="active"
                role="button"
                aria-pressed="true"
                @click="liberarOPM"
                >LIBERAR</base-button
              >
              <!-- Button to return status -->
              <base-button
                v-if="OPMaestraEditar.ProductionOrderStatus === 'boposReleased' && !loadingStatus"
                style="float: left"
                size="sm"
                tag="a"
                type="success"
                href="#"
                class="active"
                role="button"
                aria-pressed="true"
                @click="returnToPlanned"
                >REGRESAR A PLANEADO</base-button
              >
              <base-button
                v-if="!loadingStatus"
                style="float: right"
                size="sm"
                tag="a"
                type="success"
                href="#"
                class="active"
                role="button"
                aria-pressed="true"
                @click="duplicarOPM"
                >DUPLICAR OPM</base-button
              >
              <base-button
                v-if="OPMaestraEditar.ProductionOrderStatus === 'boposPlanned' || OPMaestraEditar.ProductionOrderStatus === 'boposReleased' && !loadingStatus"
                style="float: right"
                size="sm"
                tag="a"
                type="success"
                href="#"
                class="active"
                role="button"
                aria-pressed="true"
                @click="cancelOPM"
                >CANCELAR OPM</base-button
              >
              <br>
              <base-button
                v-if="!loadingStatus"
                style="float: right"
                size="sm"
                tag="a"
                type="success"
                href="#"
                class="active"
                role="button"
                aria-pressed="true"
                @click="updateOrdenMaestra"
                >GUARDAR MODIFICACIONES</base-button
              >
              
              
            </div>
            <div style="float:right" v-if="loadingStatus">
              <br>
              <img src="img/loader.gif" class="img-responsive" style="width: 50px" />
              <br />
              Aplicando...
            </div>
            <!-- 
              * * Loader UI to cancel OPM added
             -->
            
            
            <div style="float:right" v-if="cancellingOPM">
              <br>
              <img src="img/loader.gif" class="img-responsive" style="width: 50px" />
              <br />
              Cancelando la OPM...
            </div>
  
  
            <!-- <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Pedido de cliente:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Norma reparto:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Proyecto:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div> -->
          </div>
        </div>
        <hr>
        <div class="row mt-2">
          <div class="col-sm-12">
            <!-- <h4>Componentes</h4> -->
            <base-table thead-classes="thead-light" :data="OPMaestraEditar.orders">
              <template slot="columns">
                <!-- <th><center>DocEntry</center></th> -->
                <th><center>Documento</center></th>
                <th><center>Rollo a cortar</center></th>
                <th><center>Cantidad</center></th>
                <th><center>Cant. base</center></th>
                <th><center>Cant. nominal</center></th>
                <th><center>% Total</center></th>
                <th><center>Cant. adicional</center></th>
                <th><center>Cant. planificada</center></th>
                <th><center></center></th>
              </template>
              <template slot-scope="{ row, index }">
                <!-- <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.AbsoluteEntry }}</a>
                  </center>
                </th> -->
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.DocumentNumber }}</a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.ItemNo }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a v-if="getStatus(OPMaestraEditar.ProductionOrderStatus) === 'Cerrado' || getStatus(OPMaestraEditar.ProductionOrderStatus) === 'Cancelado'" style="font-size: 12px">{{ row.PlannedQuantity }} </a>
                    <base-input v-if="getStatus(OPMaestraEditar.ProductionOrderStatus) === 'Planificado' || getStatus(OPMaestraEditar.ProductionOrderStatus) === 'Liberado'" type="number" v-model="OPMaestraEditar.orders[index].PlannedQuantity" @change="updateOrderLine(OPMaestraEditar.orders[index].PlannedQuantity, index)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.ProductionOrderLines[0].BaseQuantity }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.ProductionOrderLines[0].U_NominalQty }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ ((row.ProductionOrderLines[0].U_NominalQty/OPMaestraEditar.totalNominal) * 100).toFixed(2) }} %</a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.ProductionOrderLines[0].AdditionalQuantity }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px;pointer:cursor">{{ row.ProductionOrderLines[0].PlannedQuantity }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center v-if="!cancellingLineOPM">
                    <a style="font-size: 12px; color:red; cursor:pointer" @click="cancelLineOPM(row)">Cancelar </a>
                  </center>
                  <center v-if="cancellingLineOPM === row.AbsoluteEntry">
                    Cancelando...
                  </center>
                </th>
                
              </template>            
            </base-table>
            <div style="padding-bottom:10px;padding-right:85px">
              <span style="float:right;font-size:12px;"> &nbsp;{{this.OPMaestraEditar.totalPlannedQuantity}} </span>
              <span style="float:right;font-size:12px;font-weight:bold;">Total Planificado: </span>
            </div>
            <hr>
            <table v-if="getStatus(OPMaestraEditar.ProductionOrderStatus) === 'Planificado'">
              <tr>
                <td scope="row">
                  <center>
                    <span style="font-size: 12px"></span>
                  </center>
                </td>
                <td scope="row">
                  <center>
                    <span style="font-size: 12px"></span>
                  </center>
                </td>
                <td scope="row">
                  <center>
                    <!-- <base-dropdown>
                      <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                        {{ medidaPerfilarMaster}}
                      </base-button>
                      <a
                        v-for="item in medidasOPM"
                        v-bind:key="item.ItemCode"
                        class="dropdown-item"
                        @click="medidaPerfilarMaster = item.ItemCode"
                        >{{item.ItemCode}}
                      </a>
  
                    </base-dropdown> -->
                    <multiselect
                      v-model="medidaPerfilarMaster"
                      :options="medidasOPM"
                      placeholder="Buscar"
                      label="ItemCode"
                      track-by="ItemCode"
                      @select="dispatchActionMedidaMasterEdit"
                      style="font-size:12px;margin-bottom:3px"
                    ></multiselect>
                  </center>
                </td>
                <td scope="row">
                  <center>
                    <base-input style="padding-top:24px" placeholder="Cantidad" type="number" v-model="PlannedQuantityMasterMedida" ></base-input>
                  </center>
                </td>
                <td scope="row" style="padding-left:15px">
                  <center>
                    <base-button
                      style="float: left"
                      size="sm"
                      tag="a"
                      type="success"
                      href="#"
                      class="active"
                      role="button"
                      aria-pressed="true"
                      @click="agregarMedidaMasterEdit"
                      >Agregar a la planeación</base-button>
                  </center>
                </td>
              </tr>
            </table>
            <div v-if="is06">
              <input   
                type="checkbox" 
                v-model="listaSecundaria" 
                @click="checkListaMateriales(listaSecundaria)"
              > 
              Usar lista de materiales secundaria
            </div>
              
            <!-- <base-button
              style="float: left"
              size="sm"
              tag="a"
              type="success"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="showNuevoComponente = true"
              >AGREGAR COMPONENTE</base-button
            > -->
            <!-- <base-button
              style="float: right"
              size="sm"
              tag="a"
              type="success"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="crearOrden"
              >Crear Orden de Producción</base-button
            > -->
          </div>
        </div>
        <center v-if="loaderOPM">
          <img src="img/loader.gif" class="img-responsive" style="width: 50px" />
          <br />
          Creando OPM...
        </center>
        <div>
          <!-- <base-button
            v-if="!loaderOPM"
              style="float: right"
              tag="a"
              type="primary"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="crearOrdenMaestra"
              >Modificar orden de producción</base-button
            > -->
        </div>
      </b-modal>
      <b-modal hide-footer no-close-on-backdrop no-close-on-esc hide-header-close v-model="showNuevoMaestra" size="xl" title="Nueva Orden de Fabricación Maestra" centered>
        
        <base-button 
          v-if="!loaderOPM"  
          style="float: right; margin-top: -70px"
          tag="a"
          type="decondary"
          href="#"
          class="active"
          role="button"
          aria-pressed="true"
          @click="showNuevoMaestra = false">
          X
        </base-button>
        <div class="row" style="margin-top:-35px">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Tipo:  </span>
              </div>
              <div class="col-sm-9">
                <base-input :value="getTipo(OPMaestraNueva.ProductionOrderType)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
                <!-- <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ getTipo(OPMaestraNueva.ProductionOrderType) }}
                  </base-button>
                  <a
                    class="dropdown-item"
                    @click="OPMaestraNueva.ProductionOrderType = 'bopotStandard';"
                    >Estándar
                  </a>
                  <a
                    class="dropdown-item"
                    @click="OPMaestraNueva.ProductionOrderType = 'bopotSpecial';"
                    >Especial
                  </a>
                  <a
                    class="dropdown-item"
                    @click="OPMaestraNueva.ProductionOrderType = 'bopotDisassembly';"
                    >Desmontaje
                  </a>
                </base-dropdown> -->
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Status:</span>
              </div>
              <div class="col-sm-9">
                <base-input :value="getStatus(OPMaestraNueva.ProductionOrderStatus)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px;" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span style="font-weight:normal;font-size:12px">Materia Prima: </span>
              </div>
              <div class="col-sm-9">
                <multiselect
                  v-model="NewProductMaster"
                  :options="masters"
                  placeholder="Buscar"
                  label="ItemCode"
                  track-by="ItemCode"
                  @select="dispatchActionProductMaster"
                  style="font-size:12px;margin-bottom:3px"
                ></multiselect>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Descripción de materia prima:</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="OPMaestraNueva.ProductDescription" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Cantidad planificada: </span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input type="number" v-model="OPMaestraNueva.PlannedQuantity" @change="updatePlannedQuantity" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div> -->
            <!-- <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Unidad medida</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="OPnueva.InventoryUOM" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div> -->
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Almacén: </span>
              </div>
              <div class="col-sm-9">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPMaestraNueva.Warehouse }}
                  </base-button>
                  <a
                    v-for="item in warehouses"
                    v-bind:key="item.WarehouseCode"
                    class="dropdown-item"
                    @click="OPMaestraNueva.Warehouse = item.WarehouseCode;"
                    >{{item.WarehouseCode}}
                  </a>
                </base-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Almacén de materia prima: </span>
              </div>
              <div class="col-sm-9">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPMaestraNueva.WarehouseMP }}
                  </base-button>
                  <a
                    v-for="item in warehouses"
                    v-bind:key="item.WarehouseCode"
                    class="dropdown-item"
                    @click="OPMaestraNueva.WarehouseMP = item.WarehouseCode;"
                    >{{item.WarehouseCode}}
                  </a>
                </base-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span type="number" style="font-weight:normal;font-size:12px;">Prioridad:</span>
              </div>
              <div class="col-sm-9">
                <base-input disabled type="number" v-model="OPMaestraNueva.Priority" max="100" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3" style="padding-top:10px;">
                <span style="font-weight:normal;font-size:12px">Fecha Enrutamiento:</span>
              </div>
              <div class="col-sm-9" style="padding-top:10px">
                <base-input :value="getFechaEnrutamiento(OPMaestraNueva.RoutingDateCalculation)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-4"></div> -->
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Nº:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px">Fecha del pedido:</span>
              </div>
              <div class="col-sm-6">
                <base-input :value="OPnueva.CreationDate" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Fecha de inicio:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="cursor: pointer; margin-bottom:8px">
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur;"
                    :config="{ allowInput: true }"
                    class="form-control datepicker"
                    v-model="OPMaestraNueva.StartDate"
                    style="cursor: pointer; padding-left: 20px;transform: scale(0.775);transform-origin:left"
                  >
                  </flat-picker>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Fecha de termino:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="cursor: pointer; margin-bottom:8px">
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur;"
                    :config="{ allowInput: true }"
                    class="form-control datepicker"
                    v-model="OPMaestraNueva.DueDate"
                    style="cursor: pointer; padding-left: 20px;transform: scale(0.775);transform-origin:left"
                  >
                  </flat-picker>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Usuario:</span>
              </div>
              <div class="col-sm-6">
                <base-input v-if="usersList.length > 0 && OPMaestraNueva.UserSignature" :value="getUserPerson(OPMaestraNueva.UserSignature).UserCode" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Origen:</span><br>
              </div>
              <div class="col-sm-6">
                <base-input :value="getOrigen(OPMaestraNueva.ProductionOrderOrigin)" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px" disabled></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Categoría:</span>
              </div>
              <div class="col-sm-6">
                <base-dropdown style="padding-bottom:12px;">
                  <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                    {{ OPMaestraNueva.U_CategoryDescription }}
                  </base-button>
                  <a
                    v-for="item in categories"
                    v-bind:key="item.value"
                    class="dropdown-item"
                    @click="selectCategoryMaster(item)"
                    >{{item.Description}}
                  </a>
                </base-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Merma: </span>
              </div>
              <div class="col-sm-6" style="padding-top:10px">
                <base-input type="number" v-model="OPMaestraNueva.Merma" @change="updateMerma" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Método: </span>
              </div>
              <div class="col-sm-6" style="padding-top:10px">
                <base-input disabled :value="'Corte de Master'" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Proyecto:</span>
              </div>
              <div class="col-sm-6">
                <base-input v-model="OPM_Proyecto" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
  
            <!-- <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Pedido de cliente:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Norma reparto:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Proyecto:</span>
              </div>
              <div class="col-sm-6">
                <base-input style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div> -->
          </div>
        </div>
        <hr>
        <div class="row mt-2">
          <div class="col-sm-12">
            <!-- <h4>Componentes</h4> -->
            <base-table thead-classes="thead-light" :data="OPMaestraNueva.orders">
              <template slot="columns">
                <th><center>DocEntry</center></th>
                <th><center>Documento</center></th>
                <th><center>Rollo a cortar</center></th>
                <th><center>Cantidad</center></th>
                <th><center>Cant. base</center></th>
                <th><center>Cant. nominal</center></th>
                <th><center>% Total</center></th>
                <th><center>Cant. adicional</center></th>
                <th><center>Cant. planificada</center></th>
                <th></th>
              </template>
              <template slot-scope="{ row, index }">
                <th scope="row">
                  <center>
                    <span style="font-size: 12px"> </span>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <span style="font-size: 12px"></span>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.ItemNo }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.Metros }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.BaseQuantity }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.Nominal.toFixed(5) }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.Porcentaje }} %</a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.Merma }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <a style="font-size: 12px">{{ row.PlannedQuantity }} </a>
                  </center>
                </th>
                <th scope="row">
                  <center>
                    <span style="font-size: 12px">
                      <a style="color:red;cursor:pointer;" @click="deleteItemMaster(index)"><i class="far fa-trash-alt"></i></a>
                    </span>
                  </center>
                </th>
                
              </template>       
            </base-table>
            <div style="padding-bottom:10px;padding-right:85px">
              <span style="float:right;font-size:12px;"> &nbsp;{{this.OPMaestraNueva.totalPlannedQuantity}} </span>
              <span style="float:right;font-size:12px;font-weight:bold;">Total Planificado: </span>
            </div>
            <hr>
            <table v-if="OPMaestraNueva.ItemNo">
              <tr>
                <td scope="row">
                  <center>
                    <span style="font-size: 12px"></span>
                  </center>
                </td>
                <td scope="row">
                  <center>
                    <span style="font-size: 12px"></span>
                  </center>
                </td>
                <td scope="row">
                  <center>
                    <multiselect
                      :options="medidasOPM"
                      v-model="medidaPerfilarMaster2"
                      placeholder="Selecciona una medida"
                      label="ItemCode"
                      track-by="ItemCode"
                      @select="dispatchMedidaMaster"
                      style="font-size:12px;margin-bottom:3px;width:400px"
                    ></multiselect>
                    <!-- <base-dropdown>
                      <base-button slot="title" type="secondary" class="dropdown-toggle" style="font-weight:normal">
                        {{ medidaPerfilarMaster}}
                      </base-button>
                      <a
                        v-for="item in medidasOPM"
                        v-bind:key="item.ItemCode"
                        class="dropdown-item"
                        @click="medidaPerfilarMaster = item.ItemCode"
                        >{{item.ItemCode}}
                      </a>
                    </base-dropdown> -->
                  </center>
                </td>
                <td scope="row">
                  <center>
                    <base-input style="padding-top:24px" placeholder="Cantidad" type="number" v-model="PlannedQuantityMasterMedida" ></base-input>
                  </center>
                </td>
                <td scope="row" style="padding-left:15px">
                  <center>
                    <base-button
                      style="float: left"
                      size="sm"
                      tag="a"
                      type="success"
                      href="#"
                      class="active"
                      role="button"
                      aria-pressed="true"
                      @click="agregarMedidaMaster"
                      >Agregar a la planeación</base-button>
                  </center>
                </td>
              </tr>
            </table>
            <div v-if="is06">
              <input   
                type="checkbox" 
                v-model="listaSecundaria" 
                @click="checkListaMateriales(listaSecundaria)"
              > 
              Usar lista de materiales secundaria
            </div>
              
            <!-- <base-button
              style="float: left"
              size="sm"
              tag="a"
              type="success"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="showNuevoComponente = true"
              >AGREGAR COMPONENTE</base-button
            > -->
            <!-- <base-button
              style="float: right"
              size="sm"
              tag="a"
              type="success"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="crearOrden"
              >Crear Orden de Producción</base-button
            > -->
          </div>
        </div>
        <center v-if="loaderOPM">
          <img src="img/loader.gif" class="img-responsive" style="width: 50px" />
          <br />
          Creando OPM...
        </center>
        <div>
          <base-button
            v-if="!loaderOPM"
              style="float: right"
              tag="a"
              type="primary"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="crearOrdenMaestra"
              >Crear orden de producción</base-button
            >
        </div>
      </b-modal>
      <b-modal hide-footer  v-model="showModalGoma" size="sm" title="Configuracion de goma" centered>
            <div class="row">
              <div class="col-sm-4" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Código de goma</span>
              </div>
              <div class="col-sm-8">
                <base-input v-model="gomaBase" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Gramos por m2</span>
              </div>
              <div class="col-sm-8">
                <base-input v-model="factorGoma" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4" style="padding-top:10px">
                <span style="font-weight:normal;font-size:12px;">Almacén</span>
              </div>
              <div class="col-sm-8">
                <base-input v-model="almacenGoma" style="transform: scale(0.775);transform-origin:left;margin-bottom:3px"></base-input>
              </div>
            </div>
  <!--       <div>
          <base-button
            v-if="!loaderOPM"
              style="float: right"
              tag="a"
              type="primary"
              href="#"
              class="active"
              role="button"
              aria-pressed="true"
              @click="crearOrdenMaestra"
              >Crear orden de producción</base-button
            >
        </div> -->
      </b-modal>
      <div class="container-fluid mt--9">
        <div class="row">
          <div class="col-sm-12">
            <div class="card shadow">
              <div class="card-header bg-transparent">
                <h3 class="mb-0" style="padding-top: 8px">Ordenes de producción abiertas</h3>
                <!-- <h4 class="mb-0" style="padding-top: 8px;color:#c0392b">[ Base de datos de PRUEBAS ]</h4> -->
                <base-button
                  style="float: left; margin-top:10px"
                  tag="a"
                  type="success"
                  href="#"
                  size="sm"
                  class="active"
                  role="button"
                  aria-pressed="true"
                  @click="showModalGoma = true"
                  >Configurar goma</base-button>
                <base-button
                  style="float: right"
                  tag="a"
                  type="success"
                  href="#"
                  class="active"
                  role="button"
                  aria-pressed="true"
                  @click="showNuevo = true"
                  >Nueva OP Bebé</base-button
                >
                <span style="float: right">&nbsp;</span>
                <base-button
                  style="float: right;"
                  tag="a"
                  type="success"
                  href="#"
                  class="active"
                  role="button"
                  aria-pressed="true"
                  @click="showNuevoMaestra = true"
                  >Nueva OP Maestra</base-button
                >
                <base-button
                  v-if="!listClosed"
                  style="float: left; margin-top:10px"
                  tag="a"
                  href="#"
                  size="sm"
                  class="active"
                  role="button"
                  aria-pressed="true"
                  @click="getClosedOP"
                  >Mostrar ordenes cerradas</base-button>
                <base-button
                  v-if="listClosed"
                  style="float: left; margin-top:10px"
                  tag="a"
                  href="#"
                  size="sm"
                  class="active"
                  role="button"
                  aria-pressed="true"
                  @click="getOpenOP"
                  >Mostrar ordenes abiertas</base-button>
              </div>
              <div class="row" style="padding-left:30px;padding-top:30px;">
                <div class="col-sm-12">
                  <base-input v-model="inputSearchOP" type="number" style="float:left;width:350px;padding-right:20px" placeholder="Teclea el número de orden de fabricación"></base-input>
                  <div style="padding-left:10px"> 
                    <base-button
                      style="float:left;"
                      size="m"
                      tag="a"
                      type="success"
                      class="active"
                      role="button"
                      aria-pressed="true"
                      @click="buscarOP">
                      Buscar
                    </base-button>
                  </div>
                </div>
                <div class="col-sm-12" style="padding-top:-20px">
                  <base-checkbox v-model="searchOPM">
                    ¿Es OP maestra?
                  </base-checkbox>
                </div>
              </div>
              <!-- <div style="margin:15px;z-index:9">
                <multiselect
                v-model="ProductCalendar"
                :options="products"
                v-if="products != []"
                placeholder="Busca un producto para conocer sus fechas de finalización"
                label="ProductDescription"
                track-by="TreeCode"
                @select="dispatchActionProductCalendar"
                ></multiselect>
              </div>
              <span style="margin-left:15px;" class="text-danger">{{messageEmptyOrders}}</span>
              <div style="margin:15px" v-if="attributes.length > 0">
                <span class="text-xs leading-tight rounded-sm p-2 mt-0 mb-1 bg-blue text-white">GDL</span> &nbsp;
                <span class="text-xs leading-tight rounded-sm p-2 mt-0 mb-1 bg-info text-white">MEX</span> &nbsp;
                <span class="text-xs leading-tight rounded-sm p-2 mt-0 mb-1 bg-red text-white">QRO</span> &nbsp;
                <span class="text-xs leading-tight rounded-sm p-2 mt-0 mb-1 bg-success text-white">CUU (VALIDA)</span> &nbsp;
              </div>
              <div>
                <div style="margin:15px"
                  v-if="attributes.length > 0">
                  <v-calendar
                    class="custom-calendar max-w-full"
                    style="margin-bottom:0"
                    :masks="masks"
                    :attributes="attributes"
                    disable-page-swipe
                    is-expanded
                  >
                    <template v-slot:day-content="{ day, attributes }">
                      <div class="flex flex-col z-1 overflow-hidden">
                        <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
                        <div class="flex-grow overflow-y-auto overflow-x-auto" style="height:60px;overflow:auto;">
                          <span v-for="attr in attributes" :key="attr.key" class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1" :class="attr.customData.class">
                            {{ attr.customData.title }} <br>
                          </span>
                        </div>
                      </div>
                    </template>
                  </v-calendar>
                </div>   
              </div> -->
              <div class="card-body col-sm-12">
                <div class="table-responsive">
                  <base-table
                    striped
                    hover
                    thead-classes="thead-light"
                    :data="ordersProduction"
                    style="table-layout: fixed; width: 100%"
                  >
                    <template slot="columns">
                      <th style="width: 3%">DocNum</th>
                      <th style="width: 3%">CEDIS</th>
                      <th style="width: 4%">Status</th>
                      <th style="width: 12%">Producto</th>
                      <th style="width: 4%">Cantidad</th>
                      <th style="width: 3%">Fecha <br>pedido</th>
                      <th style="width: 3%">Fecha <br>Inicio</th>
                      <th style="width: 3%;font-size:9px">Fecha <br>Vencimiento</th>
                      <th style="width: 5%;font-size:9px">Orden de <br>producción <br> maestra</th>
                    </template>
  
                    <template slot-scope="{ row }">
                      <td scope="row">
                        <span style="font-size: 12px;cursor: pointer;" > <a class="text-blue" @click="showEdicion = false; showDetalles = true; OPselected = row; NewProductEdit = {ProductDescription:row.ProductDescription, ProductTree:row.ItemNo}"> {{ row.DocumentNumber }} </a> </span>
                      </td>
                      <td scope="row">
                        <span style="font-size: 12px"> {{ row.Warehouse }} </span>
                      </td>
                      <td scope="row">
                        <!-- <span class="badge badge-dot mr-4 badge-info" v-if="getStatus(row.ProductionOrderStatus) === 'Planificado'"><i class="bg-info"></i><span class="status">{{getStatus(row.ProductionOrderStatus)}}</span></span> -->
                            <badge type="info" v-if="getStatus(row.ProductionOrderStatus) === 'Planificado'">{{getStatus(row.ProductionOrderStatus)}}</badge>
                            <badge type="danger" v-if="getStatus(row.ProductionOrderStatus) === 'Cancelado'">{{getStatus(row.ProductionOrderStatus)}}</badge>
                            <badge type="success" v-if="getStatus(row.ProductionOrderStatus) === 'Liberado'">{{getStatus(row.ProductionOrderStatus)}}</badge>
                            <badge type="default" v-if="getStatus(row.ProductionOrderStatus) === 'Cerrado'">{{getStatus(row.ProductionOrderStatus)}}</badge>
  
                        <!-- <span class="badge badge-dot mr-4 badge-success" v-if="getStatus(row.ProductionOrderStatus) === 'Cerrado'"><i class="bg-success"></i><span class="status">{{getStatus(row.ProductionOrderStatus)}}</span></span>
                        <span class="badge badge-dot mr-4 badge-success" v-if="getStatus(row.ProductionOrderStatus) === 'Liberado'"><i class="bg-success"></i><span class="status">{{getStatus(row.ProductionOrderStatus)}}</span></span>
                        <span class="badge badge-dot mr-4 badge-danger" v-if="getStatus(row.ProductionOrderStatus) === 'Cancelado'"><i class="bg-danger"></i><span class="status">{{getStatus(row.ProductionOrderStatus)}}</span></span> -->
                      </td>
                      <td scope="row">
                        <span style="font-size: 10px">{{ row.ItemNo }}</span><br>
                        <span style="font-size: 10px;font-weight:bold">{{ row.ProductDescription }}</span> <br>
                      </td>
                      <td scope="row">
                        <a style="font-size: 12px">{{ row.PlannedQuantity +" "+row.InventoryUOM}}</a>
                      </td>
                      <td scope="row">
                        <a style="font-size: 12px"> {{ row.PostingDate }} </a>
                      </td>
                      <td scope="row">
                        <a style="font-size: 12px"> {{ row.StartDate }} </a>
                      </td>
                      <td scope="row">
                        <a style="font-size: 12px"> {{ row.DueDate }} </a>
                      </td>
                      <td scope="row">
                        <span style="font-size: 12px;cursor: pointer;"> <a class="text-blue" @click="modalEditarOPM(row)"> {{row.U_MasterProduction}} </a></span>
                      </td>
                    </template>
                  </base-table>
                  <div class="mt-4 mb-4" v-if="ordersProduction.length === 0">
                    <center>
                      <img src="img/loader.gif" class="img-responsive" style="width:50px" />
                      <br />Cargando últimas ordenes...
                    </center>
                  </div>
                  <!-- <center v-if="ordersProduction.length <= 0">
                    <img
                      src="img/loader.gif"
                      class="img-responsive"
                      style="width: 50px"
                    />
                    <br />
                    Cargando ordenes de producción...
                  </center> -->
                  <div class="card-footer d-flex justify-content-end"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import VueClipboard from "vue-clipboard2";
  import BTooltipDirective from "bootstrap-vue/es/directives/tooltip";
  import { VBPopover } from "bootstrap-vue/es/directives/popover";
  import moment from "moment";
  import { getAuth, getIdToken } from "firebase/auth";
  import Multiselect from "vue-multiselect";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import axios from "axios";
  
  Vue.use(VueClipboard);
  export default {
    components: {
      Multiselect,
      flatPicker,
    },
    directives: {
      "b-tooltip": BTooltipDirective,
      "b-popover": VBPopover,
    },
    created() {
      axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
      const auth = getAuth();
      this.user = auth.currentUser;
    },
    mounted() {
      axios.get('/api/items/ends/m2')
        .then((response) => {
          this.masters = response.data
        })
      axios.get('/api/user_fields/oword/field/1')
        .then((response) => {
          this.methods = response.data
        })
      axios.get('/api/user_fields/oword/field/2')
        .then((response) => {
          this.categories = response.data
        })
      axios.get('/api/users/by/email/'+this.user.email)
        .then((response) => {
          this.OPnueva.UserSignature = response.data.value[0].InternalKey
          this.OPMaestraNueva.UserSignature = response.data.value[0].InternalKey
        })
      axios.get('/api/users/list')
        .then((response) => {
          this.usersList = response.data.value
        })
  
        axios.get("/api/production_orders/not_closed")
        .then((response) => {
          this.ordersProduction = response.data.value;
        })
        .catch((error) => {
          console.error(error);
    });
  
      axios.get('/api/warehouses/by/warehousecode')
        .then((response) => {
          this.warehouses = response.data
          if(this.user.email != "anaduarte@canplast.com.mx" && this.user.email != "daliahernandez@canplast.com.mx" && this.user.email != "rebecahernandez@canplast.com.mx" && this.user.email != "danieljimenez@canplast.com.mx" && this.user.email != "franciscoherrera@canplast.com.mx"){
            let index = this.warehouses.findIndex((element) => element.WarehouseCode == 'MEX-06')
            this.warehouses.splice(index, 1)
          }
        })
      
      axios.get('/api/product_trees/list')
        .then((response) => {
          this.products = response.data.value
        })
  
      axios.get('/api/items/not/a/tree')
      .then((response) => {
        this.productsNotTree = response.data.value
      })
  
    },
    data() {
      return {
        loadingProductTree:false,
        OPnueva:{
          ProductionOrderType: "bopotStandard",
          ProductionOrderStatus: "boposPlanned",
          Warehouse: "VALIDA",
          WarehouseMP: "CUU-06",
          Priority: null,
          RoutingDateCalculation: "raOnStartDate",
          U_Category: null,
          U_CategoryDescription: "Selecciona una categoria",
          ProductDescription: null,
          ItemNo: null,
          PlannedQuantity: null,
          InventoryUOM: null,
          U_Method: null,
          U_MethodDescription: "Lista de componentes del sistema",
          U_MasterProduction: null,
          CreationDate: moment().format("YYYY-MM-DD"),
          StartDate: moment().format("YYYY-MM-DD"),
          DueDate: moment().format("YYYY-MM-DD"),
          UserSignature: null,
          ProductionOrderOrigin: "bopooManual",
          ProductionOrderLines:[]
        },
        OPMaestraNueva:{
          orders:[],
          Merma: 0,
          ProductionOrderType: "bopotStandard",
          ProductionOrderStatus: "boposPlanned",
          Warehouse: "VALIDA",
          WarehouseMP: "CUU-06",
          Priority: null,
          RoutingDateCalculation: "raOnStartDate",
          U_Category: null,
          U_CategoryDescription: "Selecciona una categoria",
          ProductDescription: null,
          ItemNo: null,
          PlannedQuantity: null,
          InventoryUOM: null,
          U_Method: null,
          U_MethodDescription: "Lista de componentes del sistema",
          U_MasterProduction: null,
          CreationDate: moment().format("YYYY-MM-DD"),
          StartDate: moment().format("YYYY-MM-DD"),
          DueDate: moment().format("YYYY-MM-DD"),
          UserSignature: null,
          ProductionOrderOrigin: "bopooManual",
          ProductionOrderLines:[],
          totalPlannedQuantity: 0
        },
        OPM_Proyecto:null,
        OPMaestraEditar:{
          orders:[],
          Merma: 0,
          ProductionOrderType: "bopotStandard",
          ProductionOrderStatus: "boposPlanned",
          Warehouse: "Selecciona un almacén",
          WarehouseMP: "Selecciona un almacén",
          Priority: null,
          RoutingDateCalculation: "raOnStartDate",
          U_Category: null,
          U_CategoryDescription: "Selecciona una categoria",
          ProductDescription: null,
          ItemNo: null,
          PlannedQuantity: null,
          InventoryUOM: null,
          U_Method: null,
          U_MethodDescription: "Selecciona el método",
          U_MasterProduction: null,
          CreationDate: moment().format("YYYY-MM-DD"),
          StartDate: moment().format("YYYY-MM-DD"),
          DueDate: moment().format("YYYY-MM-DD"),
          UserSignature: null,
          ProductionOrderOrigin: "bopooManual",
          ProductionOrderLines:[],
          totalNominal: 0,
          totalPlannedQuantity: 0
        },
        inputSearchOP:null,
        gomaBase: "10-00590-00-NAT-0025",
        showLoaderExistencia:false,
        ItemWarehouseInfo: {
          ItemName: null,
          ItemCode: null,
          ItemWarehouseInfoCollection: []
        },
        cancellingLineOPM: null,
        showModalGoma: false,
        showExitencias:false,
        searchOPM: false,
        factorGoma:220,
        almacenGoma: 'CUU-01',
        listClosed: false,
        showExistencias:false,
        totalNominalMaster: 0,
        masters: [],
        showNuevoMaestra: false,
        loaderOPM: false,
        loaderCrearOP: false,
        medidaPerfilar: null,
        medidaPerfilarMaster:"Selecciona una medida",
        medidaPerfilarMaster2: null,
        blisterOption: "Selecciona",
        showOptionsBlister:false,
        PlannedQuantityMasterMedida: null,
        medidas: null,
        medidasOPM: [],
        categories: null,
        methods: null,
        listaSecundaria: false,
        is06: false,
        NewComponent:null,
        factor: 0.00022,
        productsNotTree: [],
        showNuevoComponente: false,
        usersList: [],
        NewProductTreeLines:[],
        NewProductNotTree: null,
        NewProduct: null,
        NewProductMaster: null,
        messageEmptyOrders: null,
        ordersProduct:[],
        ProductCalendar: null,
        NewProductEdit: null,
        products:[],
        warehouses:[],
        masks: {
          weekdays: 'WWW',
        },
        attributes:[],
        showEdicion:false,
        showEdicionOPM:false,
        edicionOPM:0,
        tipoToShow:"Selecciona un tipo",
        OPselected: null,
        showDetalles: false,
        dates: {
          CreationDate: moment().format("YYYY-MM-DD"),
          StartDate: moment().format("YYYY-MM-DD"),
          DueDate: moment().format("YYYY-MM-DD")
        },
        loadingStatus: false,
        OldProductionOrdersLines: null,
        ordersProduction:[],
        IncomingPaymentsList: [],
        showLoaderAplicando: false,
        total: null,
        showNuevo: false,
        tableData: [],
        options: [],
        selected: null,
        showLoader: true,
        cancellingOPM: false,
      };
    },
    methods: {
      deleteItemMaster(i){
        this.OPMaestraNueva.orders.splice(i, 1);
        this.updateMerma();
      },
      selectCategorySelected(item){
        this.OPselected.U_CategoryDescription = item.Description;
        this.OPselected.U_Category = item.Value; 
        if(item.Description == 'Fix'){
          this.OPselected.Priority = 100
        }
        if(item.Description == 'Flex'){
          this.OPselected.Priority = 50
        }
      },
      selectCategory(item){
        this.OPnueva.U_CategoryDescription = item.Description;
        this.OPnueva.U_Category = item.Value; 
        if(item.Description == 'Fix'){
          this.OPnueva.Priority = 100
        }
        if(item.Description == 'Flex'){
          this.OPnueva.Priority = 50
        }
      },
      selectCategoryMaster(item){
        this.OPMaestraNueva.U_CategoryDescription = item.Description;
        this.OPMaestraNueva.U_Category = item.Value; 
        if(item.Description == 'Fix'){
          this.OPMaestraNueva.Priority = 100
        }
        if(item.Description == 'Flex'){
          this.OPMaestraNueva.Priority = 50
        }
      },
      duplicarOP(){
        this.OPnueva = this.OPselected; 
        this.showDetalles=false; 
        this.showNuevo=true;
        this.OPnueva.ProductionOrderStatus = "boposPlanned";
        this.OPnueva.WarehouseMP = this.OPnueva.ProductionOrderLines[0].Warehouse
        this.OPnueva.U_CategoryDescription = this.getCategory(this.OPnueva.U_Category)
        this.OPnueva.U_MethodDescription = this.getMethod(this.OPnueva.U_Method);
        this.NewProduct = {
          ProductDescription :this.OPnueva.ProductDescription,
          TreeCode: this.OPnueva.ItemNo
        }
      },
      duplicarOPM(){
        this.OPMaestraNueva = this.OPMaestraEditar;
        this.OPMaestraNueva.ProductionOrderType = "bopotStandard";
        this.OPMaestraNueva.ProductionOrderStatus = "boposPlanned";
        
        this.OPMaestraNueva.ProductDescription = this.masters.find(master => master.ItemCode == this.OPMaestraEditar.orders[0].ProductionOrderLines[0].ItemNo).ItemName;
        
        this.NewProductMaster = { 
          ItemCode: this.OPMaestraEditar.orders[0].ProductionOrderLines[0].ItemNo
        }
        this.showNuevoMaestra = true;
        this.showEdicionOPM = false;
        this.OPMaestraNueva.totalPlannedQuantity = 0;
        this.OPMaestraNueva.ProductionOrderType = "bopotStandard";
        this.OPMaestraNueva.ProductionOrderStatus = "boposPlanned";
  
        this.OPMaestraNueva.orders.forEach((line, index) => {
          this.OPMaestraNueva.orders[index].Metros = parseFloat(line.PlannedQuantity)
          this.OPMaestraNueva.orders[index].Nominal = parseFloat(line.ProductionOrderLines[0].U_NominalQty)
          this.OPMaestraNueva.orders[index].Merma = parseFloat(line.ProductionOrderLines[0].AdditionalQuantity)
          this.OPMaestraNueva.orders[index].BaseQuantity = parseFloat(line.ProductionOrderLines[0].BaseQuantity)
          this.OPMaestraNueva.orders[index].Porcentaje = ((parseFloat(line.ProductionOrderLines[0].U_NominalQty)/this.OPMaestraNueva.totalNominal) * 100).toFixed(2);
          this.OPMaestraNueva.orders[index].PlannedQuantity = (line.ProductionOrderLines[0].U_NominalQty + ((line.ProductionOrderLines[0].U_NominalQty/this.OPMaestraNueva.totalNominal) * this.OPMaestraNueva.Merma)).toFixed(5);
          this.OPMaestraNueva.totalPlannedQuantity = parseFloat(this.OPMaestraNueva.totalPlannedQuantity) + parseFloat(this.OPMaestraNueva.orders[index].PlannedQuantity)
          this.OPMaestraNueva.orders[index].ProductionOrderStatus = "boposPlanned";
        });
      },
      cancelOPM(){
        /**
         * * Method to cancel all the Production Orders fron a Master Production Order
         * * Added a loader UI to cancel OPM
         */
        this.cancellingOPM = true;
      
        this.OPMaestraEditar.orders.forEach((element, index) => {
        const doc_entry = element.AbsoluteEntry;
  
        axios.patch(
          `/api/production_orders?doc_entry=${doc_entry}`,
          {
            ProductionOrderStatus: "boposCancelled",
          },
        )
        .then((response) => {
          if (response.data && response.data.se_err) {
            alert(response.data.se_err.message.value);
            if (index === this.OPMaestraEditar.orders.length - 1) {
              setTimeout(() => {
                axios
                  .get("/api/production_orders/not_closed")
                  .then((resp) => {
                    this.ordersProduction = resp.data.value;
                    this.loaderOPM = false;
                    this.showEdicionOPM = false;
                    this.cancellingOPM = false;
                    this.OPMaestraNueva = {
                      orders: [],
                      Merma: 0,
                      ProductionOrderType: "bopotStandard",
                      ProductionOrderStatus: "boposPlanned",
                      Warehouse: "Selecciona un almacén",
                      WarehouseMP: "Selecciona un almacén",
                      Priority: null,
                      RoutingDateCalculation: "raOnStartDate",
                      U_Category: null,
                      U_CategoryDescription: "Selecciona una categoria",
                      ProductDescription: null,
                      ItemNo: null,
                      PlannedQuantity: null,
                      InventoryUOM: null,
                      U_Method: null,
                      U_MethodDescription: "Selecciona el método",
                      U_MasterProduction: null,
                      CreationDate: moment().format("YYYY-MM-DD"),
                      StartDate: moment().format("YYYY-MM-DD"),
                      DueDate: moment().format("YYYY-MM-DD"),
                      UserSignature: null,
                      ProductionOrderOrigin: "bopooManual",
                      ProductionOrderLines: [],
                    };
                    alert("Orden de Producción Maestra Cancelada");
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              }, 2000);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
  
        
      },
      getClosedOP(){
        this.listClosed=true;
        this.ordersProduction = [];
        axios.get("/api/production_orders/closed")
        .then((response) => {
          this.ordersProduction = response.data.value;
        })
        .catch((error) => {
          console.error(error);
        });
      },
      getOpenOP(){
        this.listClosed=false;
        this.ordersProduction = [];
        axios.get("/api/production_orders/not_closed")
        .then((response) => {
          this.ordersProduction = response.data.value;
        })
        .catch((error) => {
          console.error(error);
        });
      },
      buscarOP(){
        if(this.inputSearchOP > 0){
          if(this.searchOPM){
            axios.get("/api/production_orders/opm/"+this.inputSearchOP)
            .then((responseJson) => {
              if(responseJson.data.value.length == 0){
                alert("Orden de Producción Maestra no encontrada en el sistema")
              } else {
                this.showEdicionOPM=true;
                this.edicionOPM= responseJson.data.value[0];
                this.OPMaestraEditar={
                  orders:[],
                  Merma: 0,
                  ProductionOrderType: responseJson.data.value[0].ProductionOrderType,
                  ProductionOrderStatus: responseJson.data.value[0].ProductionOrderStatus,
                  Warehouse: responseJson.data.value[0].Warehouse,
                  WarehouseMP: responseJson.data.value[0].ProductionOrderLines[0].Warehouse,
                  Priority: responseJson.data.value[0].Priority,
                  RoutingDateCalculation: responseJson.data.value[0].RoutingDateCalculation,
                  U_Category: responseJson.data.value[0].U_Category,
                  U_CategoryDescription: "Selecciona una categoria",
                  ProductDescription: null,
                  ItemNo: responseJson.data.value[0].ProductionOrderLines[0].ItemNo,
                  PlannedQuantity: null,
                  InventoryUOM: null,
                  U_Method: responseJson.data.value[0].U_Method,
                  U_MethodDescription: "Selecciona el método",
                  U_MasterProduction: responseJson.data.value[0].U_MasterProduction,
                  CreationDate: responseJson.data.value[0].CreationDate,
                  StartDate: responseJson.data.value[0].StartDate,
                  DueDate: responseJson.data.value[0].DueDate,
                  UserSignature: responseJson.data.value[0].UserSignature,
                  ProductionOrderOrigin: responseJson.data.value[0].ProductionOrderOrigin,
                  emisionMethod: responseJson.data.value[0].ProductionOrderLines[0].ProductionOrderIssueType,
                  ProductionOrderLines:[],
                  totalNominal: 0,
                  totalPlannedQuantity: 0
                }
                this.OPMaestraEditar.orders = responseJson.data.value;
                this.OPMaestraEditar.totalNominal = 0;
                this.OPMaestraEditar.Merma = 0;
  
                this.medidasOPM = [];
                axios.get('/api/items/measures/'+responseJson.data.value[0].ProductionOrderLines[0].ItemNo.slice(0, -4))
                .then((response) => {
                  this.medidasOPM = response.data.value;
                }) 
  
                this.OPMaestraEditar.orders.forEach(element => {
                  this.OPMaestraEditar.totalNominal = this.OPMaestraEditar.totalNominal + element.ProductionOrderLines[0].U_NominalQty;
                  this.OPMaestraEditar.Merma = this.OPMaestraEditar.Merma + element.ProductionOrderLines[0].AdditionalQuantity;
                  this.OPMaestraEditar.totalPlannedQuantity = (parseFloat(this.OPMaestraEditar.totalPlannedQuantity) + parseFloat(element.ProductionOrderLines[0].PlannedQuantity)).toFixed(5);
                });
              }
            })
            .catch((error) => {
              console.error(error);
            });
          }
          else{
            axios.get("/api/production_orders/by/doc_num/"+this.inputSearchOP)
            .then((response) => {
              if(response.data.value.length == 0){
                alert("Orden de Producción no encontrada en el sistema")
              } else {
                this.OPselected = response.data.value[0];
                this.showDetalles = true;
                this.inputSearchOP = null;
              }
            })
            .catch((error) => {
              console.error(error);
            });
          }
        }
        else{
          alert("Teclea el DocNum que deseas buscar")
        }
      },
      cancelLineOPM(row){
        this.cancellingLineOPM = row.AbsoluteEntry;
        var data = {
          ProductionOrderStatus: 'boposCancelled'
        }
        axios.patch("/api/production_orders?doc_entry="+row.AbsoluteEntry, data)
        .then((response) => {
          if (response.data.se_err) {
            this.loadingStatus = false;
            alert(response.data.se_err.error.message.value);
          }
          else{
            axios.get("/api/production_orders/not_closed")
            .then((response) => {
              this.ordersProduction = response.data.value;
              this.cancellingLineOPM = null;
              alert("La orden bebé ha sido cancelada correctamente")
              this.modalEditarOPM(this.edicionOPM)
            })
            .catch((error) => {
              console.error(error);
            })
              
          }
          
        })
        .catch((error) => {
          console.error(error);
        });
      },
      dispatchActionMedidaMasterEdit(item){
        //this.medidaPerfilarMaster = item.ItemCode;
      },
      cerrarOrden(){
        var isManual = false;
        var bloqueoMerma = false;
        
        this.OPselected.ProductionOrderLines.forEach((element, index) => {
          if(this.user.email != "anaduarte@canplast.com.mx" && this.user.email != "rebecahernandez@canplast.com.mx" && this.user.email != "daliahernandez@canplast.com.mx" && this.user.email != "danieljimenez@canplast.com.mx" && this.user.email != "octaviojuarez@canplast.com.mx"){
            if(element.AdditionalQuantity > ((element.PlannedQuantity * 8)/100)){
              bloqueoMerma = true;
            }
          }
          if(element.ProductionOrderIssueType === 'im_Manual'){
            isManual = true;
          }
          if(this.OPselected.ProductionOrderLines.length-1 == index){
            if(bloqueoMerma){
              alert("Esta orden excede el 8% de merma")
            } else if(isManual){
              alert("Esta orden de fabricación no puede ser cerrada, el método de emisión es de forma manual")
            }
            else{
              this.$swal({
                  title: `¿Deseas cerrar esta orden de fabricación?`,
                  showCancelButton: true,
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  customClass:{
                    container: 'custom-swal-on-top',
                  },
              })
              .then((result) => {
                if(result.isConfirmed){
                    this.loadingStatus = true;
  
                    axios.patch("/api/production_orders/closing", {
                      AbsoluteEntry: this.OPselected.AbsoluteEntry,
                      DocumentNumber: this.OPselected.DocumentNumber,
                      userEmail: this.user.email
                    })
                    .then((response) => {
                      if(response.data.se_err){
                        alert(response.data.se_err.error.message.value)
                        this.loadingStatus = false;
                      }
                      else{
                        axios.get("/api/production_orders/not_closed")
                          .then((response) => {
                            this.ordersProduction = response.data.value;
                          })
                          .catch((error) => {
                            console.error(error);
                          });
                        alert("Orden de Producción cerrada correctamente")
                        this.OPselected.ProductionOrderStatus="boposClosed"
                        this.loadingStatus = false;
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                }
              });
            }
          }
        });
        
      },
      cerrarOPM(){
        this.loadingStatus = true;
        if(this.OPMaestraEditar.emisionMethod === 'im_Manual'){
          alert("No es posible liberar esta orden, su metodo de emision debe ser forma manual")
          this.loadingStatus = false;
        }
        else{
          axios.get('/api/items/itemprice/'+this.OPMaestraEditar.ItemNo)
          .then((response2) => {
          response2.data.ItemWarehouseInfoCollection.forEach(element => {
            if(element.WarehouseCode === this.OPMaestraEditar.WarehouseMP){
              if(element.InStock < this.OPMaestraEditar.totalPlannedQuantity){
                alert("No es posible cerrar esta orden, cantidad insuficiente en el almacén seleccionado")
                this.loadingStatus = false;
              }
              else{
                var bloqueoMerma = false;
                if(this.user.email != "anaduarte@canplast.com.mx" && this.user.email != "rebecahernandez@canplast.com.mx" && this.user.email != "daliahernandez@canplast.com.mx" && this.user.email != "danieljimenez@canplast.com.mx" && this.user.email != "octaviojuarez@canplast.com.mx"){
                  this.OPMaestraEditar.orders.forEach(element => {
                    if(element.ProductionOrderLines[0].AdditionalQuantity > ((element.ProductionOrderLines[0].PlannedQuantity * 8)/100)){
                      bloqueoMerma = true;
                    }
                  });
                }
  
                if(bloqueoMerma){
                  alert("Una o varias ordenes exceden el 8% de merma")
                  this.loadingStatus = false;
                } else {
                  this.OPMaestraEditar.orders.forEach((element, index) => {
                    axios.patch("/api/production_orders/closing", {
                        AbsoluteEntry: element.AbsoluteEntry,
                        DocumentNumber: element.DocumentNumber,
                        userEmail: this.user.email
                      })
                    .then((response) => {
                      if(response.data.se_err){
                        alert("Error DocNum: "+element.DocumentNumber+" "+response.data.se_err.error.message.value)
                        this.loadingStatus = false;
                      }
                      else{
                        this.OPMaestraEditar.orders[index].ProductionOrderStatus="boposClosed"
                        if(index+1 === this.OPMaestraEditar.orders.length){
                          axios.get("/api/production_orders/not_closed")
                            .then((response) => {
                              this.ordersProduction = response.data.value;
                            })
                            .catch((error) => {
                              console.error(error);
                            });
                          alert("Orden de Producción Maestra cerrada correctamente")
                          this.loadingStatus = false;
                        }
                      }
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                  })
                }
              }
            }
          })
        });
        }
      },
      modalEditarOPM(row){
        this.showEdicionOPM=true;
        this.edicionOPM=row;
        this.OPMaestraEditar={
          orders:[],
          Merma: 0,
          ProductionOrderType: row.jajaProductionOrderType,
          ProductionOrderStatus: row.ProductionOrderStatus,
          Warehouse: row.Warehouse,
          WarehouseMP: row.ProductionOrderLines[0].Warehouse,
          Priority: row.Priority,
          RoutingDateCalculation: row.RoutingDateCalculation,
          U_Category: row.U_Category,
          U_CategoryDescription: "Selecciona una categoria",
          ProductDescription: null,
          ItemNo: row.ProductionOrderLines[0].ItemNo,
          PlannedQuantity: null,
          InventoryUOM: null,
          U_Method: row.U_Method,
          U_MethodDescription: "Selecciona el método",
          U_MasterProduction: row.U_MasterProduction,
          CreationDate: row.CreationDate,
          StartDate: row.StartDate,
          emisionMethod: row.ProductionOrderLines[0].ProductionOrderIssueType,
          DueDate: row.DueDate,
          UserSignature: row.UserSignature,
          ProductionOrderOrigin: row.ProductionOrderOrigin,
          ProductionOrderLines:[],
          totalNominal: 0,
          totalPlannedQuantity: 0
        }
        this.medidasOPM = [];
        axios.get('/api/items/measures/'+row.ProductionOrderLines[0].ItemNo.slice(0, -4))
        .then((response) => {
          this.medidasOPM = response.data.value
        }) 
        axios.get("/api/production_orders/opm/"+row.U_MasterProduction)
          .then((response) => {
            this.OPMaestraEditar.orders = response.data.value;
            this.OPMaestraEditar.totalNominal = 0;
            this.OPMaestraEditar.Merma = 0;
  
            this.OPMaestraEditar.orders.forEach(element => {
              this.OPMaestraEditar.totalNominal = this.OPMaestraEditar.totalNominal + element.ProductionOrderLines[0].U_NominalQty;
              this.OPMaestraEditar.Merma = this.OPMaestraEditar.Merma + element.ProductionOrderLines[0].AdditionalQuantity;
              this.OPMaestraEditar.totalPlannedQuantity = (parseFloat(this.OPMaestraEditar.totalPlannedQuantity) + parseFloat(element.ProductionOrderLines[0].PlannedQuantity)).toFixed(5);
            });
            
          })
          .catch((error) => {
            console.error(error);
          });
      },
      
      liberarOrden(){
        this.$swal({
            title: `¿Deseas liberar esta orden de fabricación?`,
            showCancelButton: true,
            confirmButtonText: "Si",
            cancelButtonText: "No",
            customClass:{
              container: 'custom-swal-on-top',
            },
        })
        .then((result) => {
          if(result.isConfirmed){
              this.loadingStatus = true;
              axios.patch("/api/production_orders/release", {
                  AbsoluteEntry: this.OPselected.AbsoluteEntry,
                })
              .then((response) => {
                this.loadingStatus = false;
                  axios.get("/api/production_orders/not_closed")
                    .then((response) => {
                      this.ordersProduction = response.data.value;
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                  alert("Orden de Producción liberada correctamente")
                  this.OPselected.ProductionOrderStatus="boposReleased"
                
              })
              .catch((error) => {
                console.error(error);
              });
          }
        });
      },
      returnToPlanned(){
        /**
         * * @description: Function to return a Master production order to planned status
         */
        this.OPMaestraEditar.orders.forEach((element, index) => {
          var data = {
            ProductionOrderStatus: 'boposPlanned'
          }
          axios.patch("/api/production_orders?doc_entry="+element.AbsoluteEntry, data)
          .then((response) => {
            this.OPMaestraEditar.orders[index].ProductionOrderStatus="boposPlanned"
            if(index+1 === this.OPMaestraEditar.orders.length){
              this.loadingStatus = false;
              this.showEdicionOPM = false;
              axios.get("/api/production_orders/not_closed")
                .then((response) => {
                  this.ordersProduction = response.data.value;
                })
                .catch((error) => {
                  console.error(error);
                });
              alert("Orden de Producción Maestra ha sido regresada al status Planeada")
            }
          })
          .catch((error) => {
            console.error(error);
          });
        });
      },
      liberarOPM(){
        this.loadingStatus = true;
        if(this.OPMaestraEditar.emisionMethod === 'im_Manual'){
          alert("No es posible liberar esta orden, su metodo de emision debe ser forma manual")
          this.loadingStatus = false;
        }
        else{
          axios.get('/api/items/itemprice/'+this.OPMaestraEditar.ItemNo)
          .then((response2) => {
          response2.data.ItemWarehouseInfoCollection.forEach(element => {
            if(element.WarehouseCode === this.OPMaestraEditar.WarehouseMP){
              if(element.InStock < this.OPMaestraEditar.totalPlannedQuantity){
                alert("No es posible liberar esta orden, cantidad insuficiente en el almacén seleccionado")
                this.loadingStatus = false;
              }
              else{
                this.OPMaestraEditar.orders.forEach((element, index) => {
                  fetch("/api/production_orders/release", {
                      AbsoluteEntry: element.AbsoluteEntry,
                  })
                  .then((response) => {
                    this.OPMaestraEditar.orders[index].ProductionOrderStatus="boposReleased"
                    if(index+1 === this.OPMaestraEditar.orders.length){
                      this.loadingStatus = false;
                      this.showEdicionOPM = false;
                      axios.get("/api/production_orders/not_closed")
                        .then((response) => {
                          this.ordersProduction = response.data.value;
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                      alert("Orden de Producción Maestra liberada correctamente")
                    }
                  })
                  .catch((error) => {
                    console.error(error);
                  });
                });
              }
            }
          });
        })
        }
      },
      selectMethodBlister(tipo){
        if(tipo == "tiras"){
          if(this.OPnueva.ItemNo.slice(0,2) == '17' && this.OPnueva.ItemNo.slice(9,11) != "HD"){
            this.blisterOption = "Tiras"
            this.OPnueva.ProductionOrderLines = [
              {
                ItemNo: "05"+this.OPnueva.ItemNo.slice(2,12)+"030"+this.OPnueva.ItemNo.slice(-5), 
                BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                AdditionalQuantity: 0
              },
              {
                ItemNo: this.gomaBase,
                BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                AdditionalQuantity: 0
              }
            ];
          }
          else if(this.OPnueva.ItemNo.slice(0,2) == '17' && this.OPnueva.ItemNo.slice(9,11) == "HD"){
            this.blisterOption = "Tiras"
            if(this.OPnueva.ItemNo.slice(-8,-5) === '005'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "05"+this.OPnueva.ItemNo.slice(2,9)+"00-030"+this.OPnueva.ItemNo.slice(-5), 
                  BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: this.gomaBase,
                  BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00BAG-HD-014-0017",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-MLTAG-HD-005-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                }
              ];
            }
            else if (this.OPnueva.ItemNo.slice(-8,-5) === '015'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "05"+this.OPnueva.ItemNo.slice(2,9)+"00-030"+this.OPnueva.ItemNo.slice(-5), 
                  BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: this.gomaBase,
                  BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00BAG-CP-016-0022",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00TAG-CP-001-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                }
              ];
            }
          }
          else if(this.OPnueva.ItemNo.slice(0,2) == '18' && this.OPnueva.ItemNo.slice(9,11) != "HD"){
            this.blisterOption = "Tiras"
            this.OPnueva.ProductionOrderLines = [
              {
                ItemNo: "07"+this.OPnueva.ItemNo.slice(2,12)+"050"+this.OPnueva.ItemNo.slice(-5), 
                BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                AdditionalQuantity: 0
              },
              {
                ItemNo: this.gomaBase,
                BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                AdditionalQuantity: 0
              }
            ];
          }
          else if(this.OPnueva.ItemNo.slice(0,2) == '18' && this.OPnueva.ItemNo.slice(9,11) == "HD"){
            this.blisterOption = "Tiras"
            if(this.OPnueva.ItemNo.slice(-8,-5) === '005'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "07"+this.OPnueva.ItemNo.slice(2,9)+"00-050"+this.OPnueva.ItemNo.slice(-5), 
                  BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: this.gomaBase,
                  BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00BAG-HD-014-0017",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-MNTAG-HD-005-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                }
              ];
            }
            else if (this.OPnueva.ItemNo.slice(-8,-5) === '015'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "07"+this.OPnueva.ItemNo.slice(2,9)+"00-050"+this.OPnueva.ItemNo.slice(-5), 
                  BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: this.gomaBase,
                  BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00BAG-CP-016-0022",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00TAG-CP-001-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                }
              ];
            }
          }
        }
        else if(tipo == "master engomado"){
          this.blisterOption = "Master Engomado"
          if(this.OPnueva.ItemNo.slice(0,2) == '17' && this.OPnueva.ItemNo.slice(9,11) != "HD"){
            this.blisterOption = "Master Engomado"
            this.OPnueva.ProductionOrderLines = [
              {
                ItemNo: "06"+this.OPnueva.ItemNo.slice(2,12)+"050-00M2", 
                BaseQuantity: (parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                AdditionalQuantity: 0
              }
            ];
          }
          else if(this.OPnueva.ItemNo.slice(0,2) == '17' && this.OPnueva.ItemNo.slice(9,11) == "HD"){
            this.blisterOption = "Master Engomado"
            if(this.OPnueva.ItemNo.slice(-8,-5) === '005'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "06"+this.OPnueva.ItemNo.slice(2,9)+"00-050-00M2", 
                  BaseQuantity: (parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00BAG-HD-014-0017",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-MLTAG-HD-005-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                }
              ];
            }
            else if (this.OPnueva.ItemNo.slice(-8,-5) === '015'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "06"+this.OPnueva.ItemNo.slice(2,9)+"00-050-00M2", 
                  BaseQuantity: (parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)), 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00BAG-CP-016-0022",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: "24-00TAG-CP-001-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0
                }
              ];
            }
          }
          else if(this.OPnueva.ItemNo.slice(0,2) == '18'){
            alert("No se puede utilizar la opción Master Engomado en este artículo.")
            this.blisterOption = "Tiras"
            this.OPnueva.U_MethodDescription = "Blister";
            this.OPnueva.U_Method = "3";
          }
        }
        else if(tipo == "blancos"){
          this.blisterOption = "Blancos"
          if(this.OPnueva.ItemNo.slice(0,2) == '17' && this.OPnueva.ItemNo.slice(9,11) == "HD"){
            this.blisterOption = "Blancos"
            if(this.OPnueva.ItemNo.slice(-8,-5) === '005'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: this.OPnueva.ItemNo.slice(0,9)+"00"+this.OPnueva.ItemNo.slice(11), 
                  BaseQuantity: 1, 
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-02'
                },
                {
                  ItemNo: "24-00BAG-HD-014-0017",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-01'
                },
                {
                  ItemNo: "24-MLTAG-HD-005-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-01'
                }
              ];
            }
            else if (this.OPnueva.ItemNo.slice(-8,-5) === '015'){
              this.blisterOption = "Blancos"
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: this.OPnueva.ItemNo.slice(0,9)+"00"+this.OPnueva.ItemNo.slice(11), 
                  BaseQuantity: 1, 
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-02'
                },
                {
                  ItemNo: "24-00BAG-CP-016-0022",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-01'
                },
                {
                  ItemNo: "24-00TAG-CP-001-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-01'
                }
              ];
            }
          }
          else if(this.OPnueva.ItemNo.slice(0,2) == '18' && this.OPnueva.ItemNo.slice(9,11) == "HD"){
            this.blisterOption = "Blancos"
            if(this.OPnueva.ItemNo.slice(-8,-5) === '005'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: this.OPnueva.ItemNo.slice(0,9)+"00"+this.OPnueva.ItemNo.slice(11), 
                  BaseQuantity: 1, 
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-02'
                },
                {
                  ItemNo: "24-00BAG-HD-014-0017",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-01'
                },
                {
                  ItemNo: "24-MNTAG-HD-005-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-01'
                }
              ];
            }
            else if (this.OPnueva.ItemNo.slice(-8,-5) === '015'){
              this.blisterOption = "Blancos"
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: this.OPnueva.ItemNo.slice(0,9)+"00"+this.OPnueva.ItemNo.slice(11), 
                  BaseQuantity: 1, 
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-02'
                },
                {
                  ItemNo: "24-00BAG-CP-016-0022",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-01'
                },
                {
                  ItemNo: "24-00TAG-CP-001-0001",
                  BaseQuantity: 1,
                  AdditionalQuantity: 0,
                  Warehouse: 'CUU-01'
                }
              ];
            }
          }
          else{
            alert("No se puede utilizar la opción blancos en este artículo.")
            this.blisterOption = "Selecciona"
            this.OPnueva.ProductionOrderLines = this.OldProductionOrdersLines
            this.OPnueva.U_MethodDescription = "Blister";
            this.OPnueva.U_Method = "3";
          }
        }
      },
      selectMethod(item){
        this.showOptionsBlister= false;
        this.OPnueva.U_MethodDescription = item.Description;
        this.OPnueva.U_Method = item.Value;
        this.medidaPerfilar= null; 
        if(item.Value == '0'){ 
          this.OPnueva.ProductionOrderLines = this.OldProductionOrdersLines 
        }
        if(item.Value == '2'){
          if(this.OPnueva.ItemNo.slice(0,2) == '04' || this.OPnueva.ItemNo.slice(0,2) == '06' || this.OPnueva.ItemNo.slice(0,2) == '08'){
            if(this.OPnueva.ItemNo.slice(0,2) == '04'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "01"+this.OPnueva.ItemNo.slice(2), 
                  BaseQuantity: 1, 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: this.gomaBase,
                  BaseQuantity: ((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*this.factorGoma)/1000,
                  AdditionalQuantity: 0
                }
              ];
            }
            else if(this.OPnueva.ItemNo.slice(0,2) == '06'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "05"+this.OPnueva.ItemNo.slice(2,12)+"030"+this.OPnueva.ItemNo.slice(-5), 
                  BaseQuantity: 1, 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: this.gomaBase,
                  BaseQuantity: ((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*this.factorGoma)/1000,
                  AdditionalQuantity: 0
                }
              ];
            }
            else if(this.OPnueva.ItemNo.slice(0,2) == '08'){
              this.OPnueva.ProductionOrderLines = [
                {
                  ItemNo: "07"+this.OPnueva.ItemNo.slice(2,12)+"050"+this.OPnueva.ItemNo.slice(-5), 
                  BaseQuantity: 1, 
                  AdditionalQuantity: 0
                },
                {
                  ItemNo: this.gomaBase,
                  BaseQuantity: ((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*this.factorGoma)/1000,
                  AdditionalQuantity: 0
                }
              ];
            }
            
          }
          else{
            this.showOptionsBlister= false;
            alert("No se puede utilizar el metodo engomado en rollos en este artículo.")
            this.OPnueva.ProductionOrderLines = this.OldProductionOrdersLines
            this.OPnueva.U_MethodDescription = "Corte de Master";
            this.OPnueva.U_Method = "0";
          }
        }
        else if(item.Value == '3'){
          if(this.OPnueva.ItemNo.slice(0,2) == '17' || this.OPnueva.ItemNo.slice(0,2) == '18'){
            if(this.OPnueva.ItemNo.slice(0,2) == '17'){
              this.showOptionsBlister= true;
            }
            else if(this.OPnueva.ItemNo.slice(0,2) == '18'){
              this.showOptionsBlister = true;
              if(this.OPnueva.ItemNo.slice(0,2) == '18' && this.OPnueva.ItemNo.slice(9,11) == "HD"){
                if(this.OPnueva.ItemNo.slice(-8,-5) === '005'){
                  this.OPnueva.ProductionOrderLines = [
                     {
                      ItemNo: "07"+this.OPnueva.ItemNo.slice(2,12)+"050"+this.OPnueva.ItemNo.slice(-5), 
                      BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)),
                      AdditionalQuantity: 0
                    },
                    {
                      ItemNo: this.gomaBase,
                      BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                      AdditionalQuantity: 0
                    },
                    {
                      ItemNo: "24-00BAG-HD-014-0017",
                      BaseQuantity: 1,
                      AdditionalQuantity: 0
                    },
                    {
                      ItemNo: "24-MLTAG-HD-005-0001",
                      BaseQuantity: 1,
                      AdditionalQuantity: 0
                    }
                  ];
                }
                else if (this.OPnueva.ItemNo.slice(-8,-5) === '015'){
                  this.OPnueva.ProductionOrderLines = [
                    {
                      ItemNo: "07"+this.OPnueva.ItemNo.slice(2,12)+"050"+this.OPnueva.ItemNo.slice(-5), 
                      BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)),
                      AdditionalQuantity: 0
                    },
                    {
                      ItemNo: this.gomaBase,
                      BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                      AdditionalQuantity: 0
                    },
                    {
                      ItemNo: "24-00BAG-CP-016-0022",
                      BaseQuantity: 1,
                      AdditionalQuantity: 0
                    },
                    {
                      ItemNo: "24-00TAG-CP-001-0001",
                      BaseQuantity: 1,
                      AdditionalQuantity: 0
                    }
                  ];
                }
                else{
                  alert(this.OPnueva.ItemNo.slice(-8,-5)+" - No se puede utilizar este metodo en este artículo.")
                  this.OPnueva.ProductionOrderLines = this.OldProductionOrdersLines
                  this.OPnueva.U_MethodDescription = "Blister";
                  this.OPnueva.U_Method = "3";
                }
              }
              else if(this.OPnueva.ItemNo.slice(0,2) == '18' && this.OPnueva.ItemNo.slice(9,11) != "HD"){
                this.OPnueva.ProductionOrderLines = [
                  {
                    ItemNo: "07"+this.OPnueva.ItemNo.slice(2,12)+"050"+this.OPnueva.ItemNo.slice(-5), 
                    BaseQuantity: parseInt(this.OPnueva.ItemNo.slice(-8,-5)),
                    AdditionalQuantity: 0
                  },
                  {
                    ItemNo: this.gomaBase,
                    BaseQuantity: ((((parseInt(this.OPnueva.ItemNo.slice(-2))/1000)*parseInt(this.OPnueva.ItemNo.slice(-8,-5)))*this.factorGoma)/1000).toFixed(4),
                    AdditionalQuantity: 0
                  }
                ];
              }
            }
          }
          else{
            this.showOptionsBlister= false;
            alert("No se puede utilizar el metodo blister en este artículo.")
            this.OPnueva.ProductionOrderLines = this.OldProductionOrdersLines
            this.OPnueva.U_MethodDescription = "Corte de Master";
            this.OPnueva.U_Method = "0";
          }
        }
      },
      updateOrdenMaestra(){
        this.loadingStatus = true;
        this.OPMaestraEditar.orders.forEach((element, index) => {
          if(element.DocumentNumber>0){
            var data = {
              StartDate: this.OPMaestraEditar.StartDate,
              DueDate: this.OPMaestraEditar.DueDate,
              PlannedQuantity: this.OPMaestraEditar.orders[index].PlannedQuantity,
              //UserSignature: this.OPMaestraNueva.UserSignature,
              ProductionOrderLines:[
                {
                  ItemNo:this.OPMaestraEditar.ItemNo,
                  BaseQuantity:element.ProductionOrderLines[0].BaseQuantity,
                  PlannedQuantity:parseFloat(element.ProductionOrderLines[0].PlannedQuantity),
                  AdditionalQuantity:parseFloat(element.ProductionOrderLines[0].AdditionalQuantity),
                  Warehouse: this.OPMaestraEditar.WarehouseMP,
                  U_NominalQty: parseFloat(element.ProductionOrderLines[0].U_NominalQty)
                }
              ]
            }
            axios.patch("/api/production_orders?doc_entry="+element.AbsoluteEntry, data)
            .then((response) => {
              if (response.data.se_err) {
                this.loadingStatus = false;
                alert(response.data.se_err.error.message.value);
              }
              else{
                if(index+1 === this.OPMaestraEditar.orders.length){
                  axios.get("/api/production_orders/not_closed")
                    .then((response) => {
                      this.ordersProduction = response.data.value;
                      this.modalEditarOPM(this.edicionOPM)
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                    this.loadingStatus = false;
                  alert("Orden de Producción Maestra modificada correctamente")
                }              
              }
              
            })
            .catch((error) => {
              console.error(error);
            });
          }else{
            axios.post("/api/production_orders", {...element})
            .then((response) => {
              if (response.data.se_err) {
                this.loaderOPM = false;
                alert(response.data.se_err.error.message.value);
              }
              else{
                if(index+1 === this.OPMaestraEditar.orders.length){
                  axios.get("/api/production_orders/not_closed")
                    .then((response) => {
                      this.ordersProduction = response.data.value;
                      this.modalEditarOPM(this.edicionOPM)
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                    this.loadingStatus = false;
                  alert("Orden de Producción Maestra modificada correctamente")
                }  
              }
            })
            .catch((error) => {
              console.error(error);
            });
          }
        })
      },
      crearOrdenMaestra(){
        if(this.OPMaestraNueva.Priority != null && this.OPMaestraNueva.ItemNo != null && this.OPMaestraNueva.orders.length > 0){
          this.loaderOPM = true;
          var lastOPM;
          axios.get("/api/production_orders/latest_master_production")
            .then((response2) => {
              lastOPM = parseInt(response2.data[0].U_MasterProduction);
              this.OPMaestraNueva.orders.forEach((element, index) => {
                var data = {
                  ProductionOrderType: this.OPMaestraNueva.ProductionOrderType,
                  ProductionOrderStatus: this.OPMaestraNueva.ProductionOrderStatus,
                  Warehouse: this.OPMaestraNueva.Warehouse,
                  Priority: this.OPMaestraNueva.Priority,
                  RoutingDateCalculation: this.OPMaestraNueva.RoutingDateCalculation,
                  U_Category: this.OPMaestraNueva.U_Category,
                  ItemNo: element.ItemNo,
                  PlannedQuantity: parseFloat(element.Metros),
                  U_Method: 0,
                  Remarks: "Orden de producción creada por "+this.user.email+" desde la Consola de Administración",
                  U_MasterProduction: lastOPM + 1,
                  CreationDate: this.OPMaestraNueva.CreationDate,
                  StartDate: this.OPMaestraNueva.StartDate,
                  DueDate: this.OPMaestraNueva.DueDate,
                  UserSignature: this.OPMaestraNueva.UserSignature,
                  ProductionOrderOrigin: this.OPMaestraNueva.ProductionOrderOrigin,
                  Project:this.OPM_Proyecto,
                  ProductionOrderLines:[
                    {
                      ItemNo:this.OPMaestraNueva.ItemNo,
                      BaseQuantity:element.BaseQuantity,
                      PlannedQuantity:parseFloat(element.PlannedQuantity).toFixed(5),
                      AdditionalQuantity:parseFloat(element.Merma).toFixed(5),
                      Warehouse: this.OPMaestraNueva.WarehouseMP,
                      U_NominalQty: parseFloat(element.Nominal.toFixed(5)),
                      Project:this.OPM_Proyecto,
                    }
                  ]
                }
                axios.post("/api/production_orders", {...data})
                  .then((response) => {
                    if (response.data.se_err) {
                      this.loaderOPM = false;
                      alert(response.data.se_err.error.message.value);
                    }
                    else{
                      if(index+1 === this.OPMaestraNueva.orders.length){
                        /* 
                        * * Timeout added to load correctly the changes made in the Production Orders
                        */
                        setTimeout(() => {
                          axios.get("/api/production_orders/not_closed")
                          .then((response) => {
                            this.ordersProduction = response.data.value;
                          })
                          .catch((error) => {
                            console.error(error);
                          });
                          this.loaderOPM = false;
                          this.showNuevoMaestra = false;
                          this.OPMaestraNueva={
                            orders:[],
                            Merma: 0,
                            ProductionOrderType: "bopotStandard",
                            ProductionOrderStatus: "boposPlanned",
                            Warehouse: "Selecciona un almacén",
                            WarehouseMP: "Selecciona un almacén",
                            Priority: null,
                            RoutingDateCalculation: "raOnStartDate",
                            U_Category: null,
                            U_CategoryDescription: "Selecciona una categoria",
                            ProductDescription: null,
                            ItemNo: null,
                            PlannedQuantity: null,
                            InventoryUOM: null,
                            U_Method: null,
                            U_MethodDescription: "Selecciona el método",
                            U_MasterProduction: null,
                            CreationDate: moment().format("YYYY-MM-DD"),
                            StartDate: moment().format("YYYY-MM-DD"),
                            DueDate: moment().format("YYYY-MM-DD"),
                            UserSignature: null,
                            ProductionOrderOrigin: "bopooManual",
                            ProductionOrderLines:[]
                          }
                          this.OPM_Proyecto = null
                          alert("Orden de Producción Maestra realizada correctamente")
                        }, 2000);
                      }              
                    }
                    
                  })
                  .catch((error) => {
                    console.error(error);
                  });
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
        else{
          alert("Todos los campos son obligatorios")
        }
      },
      updateMermaOP(index){
        if(this.OPselected.ProductionOrderLines[index].AdditionalQuantity.length > 0){
          this.OPselected.ProductionOrderLines[index].AdditionalQuantity = parseFloat(this.OPselected.ProductionOrderLines[index].AdditionalQuantity)
          this.OPselected.ProductionOrderLines[index].U_NominalQty = (this.OPselected.ProductionOrderLines[index].BaseQuantity * this.OPselected.PlannedQuantity).toFixed(5)
          this.OPselected.ProductionOrderLines[index].PlannedQuantity = (parseFloat(this.OPselected.ProductionOrderLines[index].AdditionalQuantity) + (this.OPselected.ProductionOrderLines[index].BaseQuantity * this.OPselected.PlannedQuantity)).toFixed(5)
        }
        else{
          this.OPselected.ProductionOrderLines[index].AdditionalQuantity = 0;
          this.OPselected.ProductionOrderLines[index].U_NominalQty = (this.OPselected.ProductionOrderLines[index].BaseQuantity * this.OPselected.PlannedQuantity).toFixed(5)
          this.OPselected.ProductionOrderLines[index].PlannedQuantity = (parseFloat(this.OPselected.ProductionOrderLines[index].AdditionalQuantity) + (this.OPselected.ProductionOrderLines[index].BaseQuantity * this.OPselected.PlannedQuantity)).toFixed(5)
        }
      },
      updateOP(){
        this.$swal({
            title: `¿Deseas modificar esta orden de fabricación?`,
            showCancelButton: true,
            confirmButtonText: "Si",
            cancelButtonText: "No",
            customClass:{
              container: 'custom-swal-on-top',
            },
        })
        .then((result) => {
          if(result.isConfirmed){
              this.showLoaderAplicando = true;
              this.OPselected.ProductionOrderLines.forEach((element, index) => {
                this.OPselected.ProductionOrderLines[index].Warehouse = this.OPselected.WarehouseMP
              });
              var data = {
                StartDate: this.OPselected.StartDate,
                DueDate: this.OPselected.DueDate,
                //UserSignature: this.OPMaestraNueva.UserSignature,
                ProductionOrderLines: this.OPselected.ProductionOrderLines,
                U_Category: this.OPselected.U_Category,
                Priority: this.OPselected.Priority,
                Warehouse: this.OPselected.Warehouse,
                PlannedQuantity: this.OPselected.PlannedQuantity
              }
              axios.patch("/api/production_orders?doc_entry="+this.OPselected.AbsoluteEntry, data)
              .then((response) => {
                axios.get("/api/production_orders/not_closed")
                .then((response) => {
                  this.ordersProduction = response.data.value;
                })
                .catch((error) => {
                  console.error(error);
                });
                this.showLoaderAplicando = false;
                this.showEdicion = false;
                this.showDetalles = false;
                alert("Orden de Producción modificada correctamente")
              })
              .catch((error) => {
                console.error(error);
              });
          }
        });
      },
      crearOrden(){
        this.$swal({
            title: `¿Deseas crear esta orden de fabricación?`,
            showCancelButton: true,
            confirmButtonText: "Si",
            cancelButtonText: "No",
            customClass:{
              container: 'custom-swal-on-top',
            },
        })
        .then((result) => {
          if(result.isConfirmed){
            this.loaderCrearOP = true;
              if(this.OPnueva.Priority != null && this.OPnueva.ItemNo != null && this.OPnueva.ProductionOrderLines.length > 0 && this.OPnueva.PlannedQuantity > 0){
                if(this.blisterOption != 'Blancos'){
                  this.OPnueva.ProductionOrderLines.forEach((element, index) => {
                    if(element.ItemNo === this.gomaBase){
                      this.OPnueva.ProductionOrderLines[index].Warehouse = this.almacenGoma
                    }
                    else{
                      this.OPnueva.ProductionOrderLines[index].Warehouse = this.OPnueva.WarehouseMP
                    }
                  });
                }
                let data = {
                  ProductionOrderType: this.OPnueva.ProductionOrderType,
                  ProductionOrderStatus: this.OPnueva.ProductionOrderStatus,
                  Warehouse: this.OPnueva.Warehouse,
                  Priority: this.OPnueva.Priority,
                  RoutingDateCalculation: this.OPnueva.RoutingDateCalculation,
                  U_Category: this.OPnueva.U_Category,
                  //ProductDescription: this.OPnueva.ProductDescription,
                  ItemNo: this.OPnueva.ItemNo,
                  PlannedQuantity: this.OPnueva.PlannedQuantity,
                  //InventoryUOM: null,
                  U_Method: this.OPnueva.U_Method,
                  U_MasterProduction: this.OPnueva.U_MasterProduction,
                  CreationDate: this.OPnueva.CreationDate,
                  StartDate: this.OPnueva.StartDate,
                  DueDate: this.OPnueva.DueDate,
                  Remarks: "Orden de producción creada por "+this.user.email+" desde la Consola de Administración",
                  UserSignature: this.OPnueva.UserSignature,
                  ProductionOrderOrigin: this.OPnueva.ProductionOrderOrigin,
                  ProductionOrderLines:this.OPnueva.ProductionOrderLines
                }
                if(this.OPnueva.U_Method == '1'){
                  data.ProductionOrderLines = data.ProductionOrderLines.filter(item => !item.ItemNo.endsWith('M2'));
                }
                axios.post("/api/production_orders", {...data})
                .then((response) => {
                  if (response.data.se_error) {
                    alert(response.data.se_err.error.message.value);
                  }
                  else{
                    axios.get("/api/production_orders/not_closed")
                      .then((response) => {
                        this.ordersProduction = response.data.value;
                      })
                      .catch((error) => {
                        console.error(error);
                      });
                    this.showOptionsBlister= false;
                    this.OPnueva = {
                      ProductionOrderType: "bopotStandard",
                      ProductionOrderStatus: "boposPlanned",
                      Warehouse: "VALIDA",
                      WarehouseMP: "CUU-06",
                      Priority: null,
                      RoutingDateCalculation: "raOnStartDate",
                      U_Category: null,
                      U_CategoryDescription: "Selecciona una categoria",
                      ProductDescription: null,
                      ItemNo: null,
                      PlannedQuantity: null,
                      InventoryUOM: null,
                      U_Method: null,
                      blisterOption: null,
                      U_MethodDescription: "Lista de componentes del sistema",
                      U_MasterProduction: null,
                      CreationDate: moment().format("YYYY-MM-DD"),
                      StartDate: moment().format("YYYY-MM-DD"),
                      DueDate: moment().format("YYYY-MM-DD"),
                      UserSignature: null,
                      ProductionOrderOrigin: "bopooManual",
                      ProductionOrderLines:[]
                    }
                    alert("Orden de Producción realizada correctamente")
                  }
                  this.loaderCrearOP = false;
                  this.showNuevo = false;
                })
                .catch((error) => {
                  console.error(error);
                });
              }
              else{
                alert("Todos los campos son obligatorios")
              }
          }
        });
      },
      checkListaMateriales(listaSecundaria){
        //17-10638-HD-015-0019
        if(listaSecundaria == false){
          this.OPnueva.U_Method = null;
          this.OPnueva.U_MethodDescription = "Lista de componentes del sistema";
          this.showOptionsBlister = false;
          this.blisterOption= "Selecciona";
          axios.get('/api/product_trees/by/tree_code/'+this.OPnueva.ItemNo)
          .then((response) => {
            this.OPnueva.ProductionOrderLines = [];
            response.data.ProductTreeLines.forEach(element => {
              this.OPnueva.ProductionOrderLines.push({
                ItemNo:element.ItemCode,
                BaseQuantity:element.Quantity,
                PlannedQuantity:element.Quantity*this.OPnueva.PlannedQuantity,
                ProductionOrderIssueType:element.IssueMethod,
                AdditionalQuantity:0,
                IssuedQuantity:0,
                ItemType: element.ItemType,
                Warehouse: element.Warehouse,
              })
            });
            this.OldProductionOrdersLines = this.OPnueva.ProductionOrderLines;
          });
        }
        /* if(listaSecundaria == false && this.is06){
          this.OPnueva.U_MethodDescription = "Corte de Master"
          this.OPnueva.U_Method = "0"
          this.OldProductionOrdersLines = this.OPnueva.ProductionOrderLines;
          this.OPnueva.ProductionOrderLines = []
          this.OPnueva.ProductionOrderLines.push({
            ItemNo: this.OPnueva.ItemNo.slice(0, -4)+"00M2",
            BaseQuantity: parseFloat(this.OPnueva.ItemNo.slice(-4))/1000,
            AdditionalQuantity: 0
          })
        }
        else if(listaSecundaria == true && this.is06){
          this.OPnueva.ProductionOrderLines = this.OldProductionOrdersLines;
          this.OldProductionOrdersLines = null;
          01-55874-00-045-00M2
        } */
      },
      dispatchActionNewComponent(prop){
        this.NewComponent = {
          ItemNo:prop.ItemCode,
          BaseQuantity:(this.factor*parseFloat(this.OPnueva.ItemNo.slice(-4))).toFixed(5),
          PlannedQuantity:(this.OPnueva.PlannedQuantity*this.factor*parseFloat(this.OPnueva.ItemNo.slice(-4))).toFixed(5),
          /* ProductionOrderIssueType:element.IssueMethod,
          AdditionalQuantity:0,
          IssuedQuantity:0,
          ItemType: element.ItemType,
          Warehouse: element.Warehouse, */
        }
      },
      getUserPerson(userKey){
        var array = this.usersList;
        return array.find(element => element.InternalKey == userKey);
      },
      getTipo(tipo){
        if(tipo === "bopotStandard"){
          return "Estándar"
        }
        if(tipo === "bopotSpecial"){
          return "Especial"
        }
        else{
          return tipo
        }
      },
      verStock(item){
        this.showExistencias=true;
        this.showLoaderExistencia = true;
        axios.get('/api/items/itemprice/'+item)
          .then((response2) => {
            this.ItemWarehouseInfo = {
              ItemName: response2.data.ItemName,
              ItemCode: response2.data.ItemCode,
              ItemWarehouseInfoCollection: []
            };
            
            response2.data.ItemWarehouseInfoCollection.forEach(element => {
              if(element.InStock > 0){
                this.ItemWarehouseInfo.ItemWarehouseInfoCollection.push(element)
              }
            });
            this.showLoaderExistencia = false;
          })
      },
      agregarPerfilado(item){
        this.OPnueva.ProductionOrderLines = [{ItemNo: item.ItemCode, BaseQuantity: this.OPnueva.ItemNo.slice(-4)/item.ItemCode.slice(-4), AdditionalQuantity: 0}];
        this.medidaPerfilar = item.ItemCode
      },
      getMethod(metodo){
        if(metodo === "0"){
          return "Corte de Master"
        }
        else if(metodo === "1"){
          return "Perfilado"
        }
        else if(metodo === "2"){
          return "Engomado Rollos"
        }
        else if(metodo === "3"){
          return "Blister"
        }
        else{
          return metodo
        }
      },
      getStatus(status){
        if(status === "boposPlanned"){
          return "Planificado"
        }
        else if(status === "boposClosed"){
          return "Cerrado"
        }
        else if(status === "boposReleased"){
          return "Liberado"
        }
        else if(status === "boposCancelled"){
          return "Cancelado"
        }
        else{
          return status
        }
      },
      getMetodo(metodo){
        if(metodo === "0"){
          return "Corte"
        }
        else if(metodo === "1"){
          return "Perfilado"
        }
        else if(metodo === "2"){
          return "Engomado"
        }
        else if(metodo === "3"){
          return "Blister"
        }
        else{
          return metodo
        }
      },
      getOrigen(origen){
        if(origen === "bopooManual"){
          return "Manual"
        }
        else{
          return origen
        }
      },
      getCategory(category){
        if(category === "0"){
          return "Fix"
        }
        else if(category === "1"){
          return "Flex"
        }
        else{
          return category
        }
      },
      getFechaEnrutamiento(value){
        if(value === "raOnStartDate"){
          return "En fecha de inicio"
        }
        else{
          return value
        }
      },
      getEmision(value){
        if(value === "im_Backflush"){
          return "Automático"
        }
        else if(value === "im_Manual"){
          return "Manual"
        }
        else{
          return value
        }
      },
      dispatchActionProductCalendar(prop){
        this.attributes = [];
        this.messageEmptyOrders = null;
        axios.get('/api/production_orders/by/item/'+prop.TreeCode)
        .then((response) => {
          this.ordersProduct = response.data.value
          if(this.ordersProduct.length == 0){
            this.messageEmptyOrders = "Este artículo no tiene ninguna orden de producción programada"
          }
          response.data.value.forEach((element, key) => {
            var color = "gray"
            if(element.Warehouse.slice(0,3) === "VAL"){
              color = "success"
            }
            else if(element.Warehouse.slice(0,3) === "CUU"){
              color = "orange"
            }
            else if(element.Warehouse.slice(0,3) === "GDL"){
              color = "blue"
            }
            else if(element.Warehouse.slice(0,3) === "MEX"){
              color = "info"
            }
            else if(element.Warehouse.slice(0,3) === "QRO"){
              color = "red"
            }
            
  
            var date = new Date(element.DueDate);
            date.setDate(date.getDate() + 1);
  
            this.attributes.push({
              key: key,
  
              customData: {
                title: element.PlannedQuantity + ' ' + element.InventoryUOM,
                class: 'bg-'+color+' text-white',
              },
              dates: date
            })
          });
        })
      },
      dispatchActionProductEdit(prop){
        this.OPselected.ProductDescription = prop.ProductDescription;
        this.OPselected.ItemNo = prop.TreeCode;
        this.NewProductEdit = null;
      },
      updatePlannedQuantity(){
        this.OPnueva.ProductionOrderLines.forEach((element, index) => {
          this.OPnueva.ProductionOrderLines[index].PlannedQuantity = element.BaseQuantity*this.OPnueva.PlannedQuantity
        });
      },
      updatePlannedQuantitySelected(){
        this.OPselected.ProductionOrderLines.forEach((element, index) => {
          this.OPselected.ProductionOrderLines[index].U_NominalQty = (this.OPselected.ProductionOrderLines[index].BaseQuantity * this.OPselected.PlannedQuantity).toFixed(5)
          this.OPselected.ProductionOrderLines[index].PlannedQuantity = (parseFloat(this.OPselected.ProductionOrderLines[index].AdditionalQuantity) + (this.OPselected.ProductionOrderLines[index].BaseQuantity * this.OPselected.PlannedQuantity)).toFixed(5)
        });
      },
      updatePlannedQuantityMaster(){
        this.OPnueva.ProductionOrderLines.forEach((element, index) => {
          this.OPnueva.ProductionOrderLines[index].PlannedQuantity = element.BaseQuantity*this.OPnueva.PlannedQuantity
        });
      },
      updateMermaOPM(){
        this.totalNominalMaster = 0;
        this.OPMaestraEditar.totalNominal = 0;
        this.OPMaestraEditar.totalPlannedQuantity = 0;
        //this.OPMaestraEditar.Merma = 0;
        //var merma = 0;
        this.OPMaestraEditar.orders.forEach(element => {
          this.OPMaestraEditar.totalNominal = this.OPMaestraEditar.totalNominal + element.ProductionOrderLines[0].U_NominalQty;
          //merma = merma + element.ProductionOrderLines[0].AdditionalQuantity;
        });
        
        setTimeout(() => {
          this.OPMaestraEditar.orders.forEach((element,index) => {
            //this.OPMaestraEditar.orders[index].Porcentaje = ((element.ProductionOrderLines[0].U_NominalQty/this.OPMaestraEditar.totalNominal) * 100).toFixed(2);
            this.OPMaestraEditar.orders[index].ProductionOrderLines[0].AdditionalQuantity = ((element.ProductionOrderLines[0].U_NominalQty/this.OPMaestraEditar.totalNominal) *  this.OPMaestraEditar.Merma).toFixed(5),
            this.OPMaestraEditar.orders[index].ProductionOrderLines[0].PlannedQuantity = (element.ProductionOrderLines[0].U_NominalQty + ((element.ProductionOrderLines[0].U_NominalQty/this.OPMaestraEditar.totalNominal) * this.OPMaestraEditar.Merma)).toFixed(5)
            this.OPMaestraEditar.totalPlannedQuantity = (parseFloat(this.OPMaestraEditar.totalPlannedQuantity) + parseFloat(this.OPMaestraEditar.orders[index].ProductionOrderLines[0].PlannedQuantity)).toFixed(5)
  
          })
        }, 1000);
      },
      updateMerma(){
        this.totalNominalMaster = 0;
        this.OPMaestraNueva.totalPlannedQuantity = 0;
        this.OPMaestraNueva.orders.forEach(element => {
          this.totalNominalMaster = this.totalNominalMaster + element.Nominal
        });
        
        setTimeout(() => {
          this.OPMaestraNueva.orders.forEach((element,index) => {
            this.OPMaestraNueva.orders[index].Porcentaje = ((element.Nominal/this.totalNominalMaster) * 100).toFixed(2);
            this.OPMaestraNueva.orders[index].Merma = ((element.Nominal/this.totalNominalMaster) *  this.OPMaestraNueva.Merma).toFixed(5),
            this.OPMaestraNueva.orders[index].PlannedQuantity = (element.Nominal + ((element.Nominal/this.totalNominalMaster) * this.OPMaestraNueva.Merma)).toFixed(5)
            this.OPMaestraNueva.totalPlannedQuantity = parseFloat(this.OPMaestraNueva.totalPlannedQuantity) + parseFloat(this.OPMaestraNueva.orders[index].PlannedQuantity)
          })
        }, 1000);
      },
      dispatchMedidaMaster(item){
        this.medidaPerfilarMaster = item.ItemCode;
      },
      updateOrderLine(PlannedQuantity, index){
        if(this.OPMaestraEditar.orders[index].ItemNo.slice(0,2) == '17'){
          this.OPMaestraEditar.orders[index].ProductionOrderLines[0].BaseQuantity= (parseInt(this.OPMaestraEditar.orders[index].ItemNo.slice(-2))/1000)*parseInt(this.OPMaestraEditar.orders[index].ItemNo.slice(-8,-5))
          this.OPMaestraEditar.orders[index].ProductionOrderLines[0].U_NominalQty= parseFloat(this.OPMaestraEditar.orders[index].ProductionOrderLines[0].BaseQuantity) * parseFloat(PlannedQuantity); 
        }
        else{
          this.OPMaestraEditar.orders[index].ProductionOrderLines[0].U_NominalQty= parseFloat(this.OPMaestraEditar.orders[index].ProductionOrderLines[0].BaseQuantity) * parseFloat(PlannedQuantity); 
        }
        this.updateMermaOPM()
      },
      agregarMedidaMasterEdit(){
        this.medidaPerfilarMaster = this.medidaPerfilarMaster.ItemCode
        if(this.medidaPerfilarMaster != "Selecciona una medida" && this.PlannedQuantityMasterMedida > 0){
          this.OPMaestraEditar.totalPlannedQuantity = 0;
  
          
          if(this.medidaPerfilarMaster.slice(0,2) == '17'){
  
            this.OPMaestraEditar.orders.push({
              ItemNo: this.medidaPerfilarMaster,
              PlannedQuantity: this.PlannedQuantityMasterMedida,
              ProductionOrderLines: [{
                ItemNo: this.OPMaestraEditar.ItemNo,
                AdditionalQuantity: 0,
                Warehouse: this.OPMaestraEditar.WarehouseMP,
                BaseQuantity: (parseFloat(this.medidaPerfilarMaster.slice(-2))/1000)*parseFloat(this.medidaPerfilarMaster.slice(-8,-5)),
                U_NominalQty: ((parseFloat(this.medidaPerfilarMaster.slice(-2))/1000)*parseFloat(this.medidaPerfilarMaster.slice(-8,-5))) * parseFloat(this.PlannedQuantityMasterMedida),
              }],
              ProductionOrderType: this.OPMaestraEditar.ProductionOrderType,
              ProductionOrderStatus: this.OPMaestraEditar.ProductionOrderStatus,
              Warehouse: this.OPMaestraEditar.Warehouse,
              Priority: this.OPMaestraEditar.Priority,
              RoutingDateCalculation: this.OPMaestraEditar.RoutingDateCalculation,
              U_Category: this.OPMaestraEditar.orders[0].U_Category,
              U_Method: 0,
              Remarks: "Orden de producción creada por "+this.user.email+" desde la Consola de Administración",  
              U_MasterProduction: this.OPMaestraEditar.U_MasterProduction,
              StartDate: this.OPMaestraEditar.StartDate,
              DueDate: this.OPMaestraEditar.DueDate,
              ProductionOrderOrigin: this.OPMaestraEditar.ProductionOrderOrigin,
            })
  
          }
          else{
            
            this.OPMaestraEditar.orders.push({
              ItemNo: this.medidaPerfilarMaster,
              PlannedQuantity: this.PlannedQuantityMasterMedida,
              ProductionOrderLines: [{
                ItemNo: this.OPMaestraEditar.ItemNo,
                AdditionalQuantity: 0,
                Warehouse: this.OPMaestraEditar.WarehouseMP,
                BaseQuantity: (this.medidaPerfilarMaster.slice(-4))/1000,
                U_NominalQty: (this.medidaPerfilarMaster.slice(-4))/1000 * this.PlannedQuantityMasterMedida,
              }],
              ProductionOrderType: this.OPMaestraEditar.ProductionOrderType,
              ProductionOrderStatus: this.OPMaestraEditar.ProductionOrderStatus,
              Warehouse: this.OPMaestraEditar.Warehouse,
              Priority: this.OPMaestraEditar.Priority,
              RoutingDateCalculation: this.OPMaestraEditar.RoutingDateCalculation,
              U_Category: this.OPMaestraEditar.orders[0].U_Category,
              U_Method: 0,
              Remarks: "Orden de producción creada por "+this.user.email+" desde la Consola de Administración",  
              U_MasterProduction: this.OPMaestraEditar.U_MasterProduction,
              StartDate: this.OPMaestraEditar.StartDate,
              DueDate: this.OPMaestraEditar.DueDate,
              ProductionOrderOrigin: this.OPMaestraEditar.ProductionOrderOrigin,
            })
          }

          this.OPMaestraEditar.totalNominal = 0;
          this.OPMaestraEditar.orders.forEach(element => {
            this.OPMaestraEditar.totalNominal = this.OPMaestraEditar.totalNominal + element.ProductionOrderLines[0].U_NominalQty
          });
          
          setTimeout(() => {
            this.OPMaestraEditar.orders.forEach((element,index) => {
              //this.OPMaestraEditar.orders[index].ProductionOrderLines[0].Porcentaje = ((element.U_NominalQty/this.OPMaestraEditar.totalNominal) * 100).toFixed(2);
              this.OPMaestraEditar.orders[index].ProductionOrderLines[0].AdditionalQuantity = ((element.U_NominalQty/this.OPMaestraEditar.totalNominal) *  this.OPMaestraEditar.AdditionalQuantity).toFixed(5),
              this.OPMaestraEditar.orders[index].ProductionOrderLines[0].PlannedQuantity = (element.U_NominalQty + ((element.U_NominalQty/this.OPMaestraEditar.totalNominal) * this.OPMaestraEditar.AdditionalQuantity)).toFixed(5)
              this.OPMaestraEditar.totalPlannedQuantity = (parseFloat(this.OPMaestraEditar.totalPlannedQuantity) + parseFloat((element.U_NominalQty + ((element.U_NominalQty/this.OPMaestraEditar.totalNominal) * this.OPMaestraEditar.AdditionalQuantity))).toFixed(5))
            })
            this.medidaPerfilarMaster = "Selecciona una medida"
            this.medidaPerfilarMaster2 = null;
            this.PlannedQuantityMasterMedida = null;
            this.updateMermaOPM();
          }, 1000);
        }
        else{
          alert("Por favor selecciona una medida y cantidad")
        }
      },
      agregarMedidaMaster(){
        if(this.medidaPerfilarMaster != "Selecciona una medida" && this.PlannedQuantityMasterMedida > 0){
          this.OPMaestraNueva.totalPlannedQuantity = 0;
          /**
           * * Show Warning Alert to notify mix of items when add it to a Master Work Order
          */
          if((this.medidaPerfilarMaster.slice(0,2) == '06' && this.NewProductMaster.ItemCode.slice(0,2) == '05') || (this.medidaPerfilarMaster.slice(0,2) == '05' && this.NewProductMaster.ItemCode.slice(0,2) == '06') ){
            alert("Haz mezclado artículos con/sin adhesivos")
          }
  
          if((this.medidaPerfilarMaster.slice(12,15) == '045' && this.NewProductMaster.ItemCode.slice(12,15) == '100') || (this.medidaPerfilarMaster.slice(12,15) == '100' && this.NewProductMaster.ItemCode.slice(12,15) == '045') ){
            alert("Haz mezclado espesores 045 y 100")
          }
          if(this.medidaPerfilarMaster.slice(0,2) == '17'){
            this.OPMaestraNueva.orders.push({
              ItemNo: this.medidaPerfilarMaster,
              BaseQuantity: (parseInt(this.medidaPerfilarMaster.slice(-2))/1000)*parseInt(this.medidaPerfilarMaster.slice(-8,-5)),
              //BaseQuantity: (this.medidaPerfilarMaster.slice(-4))/1000,
              Metros: this.PlannedQuantityMasterMedida,
              Nominal: ((parseInt(this.medidaPerfilarMaster.slice(-2))/1000)*parseInt(this.medidaPerfilarMaster.slice(-8,-5))) * parseFloat(this.PlannedQuantityMasterMedida),
              //Nominal: (this.medidaPerfilarMaster.slice(-4))/1000 * this.PlannedQuantityMasterMedida,
              Porcentaje: 0,
              Merma: 0,
              PlannedQuantity: 0
            })
          }
          else{
            this.OPMaestraNueva.orders.push({
              ItemNo: this.medidaPerfilarMaster,
              BaseQuantity: (this.medidaPerfilarMaster.slice(-4))/1000,
              Metros: this.PlannedQuantityMasterMedida,
              Nominal: (this.medidaPerfilarMaster.slice(-4))/1000 * this.PlannedQuantityMasterMedida,
              Porcentaje: 0,
              Merma: 0,
              PlannedQuantity: 0
            })
          }
          
          
  
          this.totalNominalMaster = 0;
          this.OPMaestraNueva.orders.forEach(element => {
            this.totalNominalMaster = this.totalNominalMaster + element.Nominal
          });
          
          setTimeout(() => {
            this.OPMaestraNueva.orders.forEach((element,index) => {
              this.OPMaestraNueva.orders[index].Porcentaje = ((element.Nominal/this.totalNominalMaster) * 100).toFixed(2);
              this.OPMaestraNueva.orders[index].Merma = ((element.Nominal/this.totalNominalMaster) *  this.OPMaestraNueva.Merma).toFixed(5),
              this.OPMaestraNueva.orders[index].PlannedQuantity = (element.Nominal + ((element.Nominal/this.totalNominalMaster) * this.OPMaestraNueva.Merma)).toFixed(5)
              this.OPMaestraNueva.totalPlannedQuantity = parseFloat(this.OPMaestraNueva.totalPlannedQuantity) + parseFloat(this.OPMaestraNueva.orders[index].PlannedQuantity)
            })
            this.medidaPerfilarMaster = "Selecciona una medida"
            this.medidaPerfilarMaster2 = null;
            this.PlannedQuantityMasterMedida = null;
          }, 1000);
        }
        else{
          alert("Por favor selecciona una medida y cantidad")
        }
      },
      dispatchActionProductMaster(prop){
        this.OPMaestraNueva.ItemNo = prop.ItemCode;
        this.OPMaestraNueva.ProductDescription = prop.ItemName
        this.medidasOPM = [];
        axios.get('/api/items/measures/'+prop.ItemCode.slice(0, -4))
        .then((response) => {
          this.medidasOPM = response.data.value
        }) 
      },
      dispatchActionProductNew(prop){
        this.loadingProductTree = true;
        if(prop.TreeCode.slice(0,2) === "06"){
          this.is06 = true;
        }
        else{
          this.is06 = false;
        }
  
        this.medidas = null;
        this.OldProductionOrdersLines = null;
        this.OPnueva.ProductionOrderLines = [];
        this.OPnueva.ProductDescription = prop.ProductDescription;
        this.OPnueva.ItemNo = prop.TreeCode;
        this.OPnueva.InventoryUOM = "";
        this.OPnueva.U_Method = null,
        this.OPnueva.U_MethodDescription = "Lista de componentes del sistema"
        this.blisterOption = "Selecciona";
        this.showOptionsBlister = false;
        axios.get('/api/product_trees/by/tree_code/'+prop.TreeCode)
        .then((response) => {
          response.data.ProductTreeLines.forEach(element => {
            axios.get('/api/items/itemprice/'+element.ItemCode)
            .then((response2) => {
              response2.data.ItemWarehouseInfoCollection.forEach(element2 => {
                if(element2.WarehouseCode === this.OPnueva.WarehouseMP){
                  this.OPnueva.ProductionOrderLines.push({
                    ItemNo:element.ItemCode,
                    BaseQuantity:element.Quantity,
                    PlannedQuantity:element.Quantity*this.OPnueva.PlannedQuantity,
                    ProductionOrderIssueType:element.IssueMethod,
                    AdditionalQuantity:0,
                    IssuedQuantity:0,
                    ItemType: element.ItemType,
                    Warehouse: element.Warehouse,
                    //InStock: element2.InStock
                  })
                }
              });
              this.loadingProductTree = false;
            })
            
          });
          this.OldProductionOrdersLines = this.OPnueva.ProductionOrderLines;
        });
        axios.get('/api/items/measures/'+prop.TreeCode)
        .then((response) => {
          this.medidas = response.data.value
          this.loadingProductTree = false;
        })  
      },
    },
  };
  </script>
  <style>
  .custom-swal-on-top {
    z-index: 9999 !important;
  }
  </style>
  <style lang="postcss" scoped>
  ::-webkit-scrollbar {
    width: 0px;
  }
  ::-webkit-scrollbar-track {
    display: none;
  }
  /deep/ .custom-calendar.vc-container {
    --day-border: 1px solid #b8c2cc;
    --day-border-highlight: 1px solid #b8c2cc;
    --day-width: 90px;
    --day-height: 90px;
    --weekday-bg: #f8fafc;
    --weekday-border: 1px solid #eaeaea;
    border-radius: 0;
    width: 100%;
    & .vc-header {
      background-color: #f1f5f8;
      padding: 10px 0;
    }
    & .vc-weeks {
      padding: 0;
    }
    & .vc-weekday {
      background-color: var(--weekday-bg);
      border-bottom: var(--weekday-border);
      border-top: var(--weekday-border);
      padding: 5px 0;
    }
    & .vc-day {
      padding: 0 5px 3px 5px;
      text-align: left;
      height: var(--day-height);
      min-width: var(--day-width);
      background-color: white;
      &.weekday-1,
      &.weekday-7 {
        background-color: #eff8ff;
      }
      &:not(.on-bottom) {
        border-bottom: var(--day-border);
        &.weekday-1 {
          border-bottom: var(--day-border-highlight);
        }
      }
      &:not(.on-right) {
        border-right: var(--day-border);
      }
    }
    & .vc-day-dots {
      margin-bottom: 5px;
    }
  }
  </style>
  